window.slate = window.slate || {};
window.theme = window.theme || {};

//Create Vars that match SCSS breakpoints, defined in variables.scss.liquid file.
var screenSM = 576,
	screenMD = 768,
	screenLG = 992,
    screenXL = 1200;
    
var slickPrevArrow = "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-left' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z'></path></svg></button>",
    slickNextArrow = "<button class='slick-next slick-arrow' aria-label='Next' type='button'><svg aria-hidden='true' data-prefix='fal' data-icon='chevron-right' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path d='M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z'></path></svg></button>";

//if no image available, load the SVG placeholder image. Generate by the liquid tag {{ 'product-1' | placeholder_svg_tag: 'svg-placeholder' }}
var svgPlaceholder = '<svg class="svg-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
//BG Function for rounding numbers to the nearest two decimal places.
function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

//BG: The below function is used by both the Recently Viewed and Related Products. When looping through the products, we use the below as a template.
function outputProduct(data, outputLocation) {
  var imageRatioClass = $(outputLocation).attr("data-image-ratio"),
    priceLabel = $(outputLocation).attr("data-price-label"),
    buttonText = $(outputLocation).attr("data-button-text"),
    taxPercentage = $(outputLocation).attr("data-tax-percentage");

  if (priceLabel) {
    var priceLabelText = priceLabel;
  } else {
    var priceLabelText = "Starting from";
  }

  if (buttonText) {
    var btnText = buttonText;
  } else {
    var btnText = "Buy Now";
  }

  if (taxPercentage) {
    taxPercentage = parseFloat(taxPercentage);
    var priceWithTax = data.price * taxPercentage;
    priceWithTax = roundToTwo(priceWithTax);
    //Get Cart Total Cost (format it) & Cart Count.
    var productPrice = slate.Currency.formatMoney(
      priceWithTax,
      theme.moneyFormat
    );
  } else {
    //Get Cart Total Cost (format it) & Cart Count.
    var productPrice = slate.Currency.formatMoney(
      data.price,
      theme.moneyFormat
    );
  }

  var productHTML = "";
  productHTML += '<div class="featured-product">';
  productHTML += '<div class="product-image">';
  productHTML +=
    '<a href="/products/' +
    data.handle +
    '" title="' +
    data.title +
    '" class="' +
    imageRatioClass +
    '">';
  if (data.featured_image != null) {
    productHTML +=
      '<img data-sizes="auto" data-src="' +
      slate.Image.getSizedImageUrl(data.featured_image, "400x") +
      '" data-srcset="' +
      slate.Image.getSizedImageUrl(data.featured_image, "400x") +
      " 400w, " +
      slate.Image.getSizedImageUrl(data.featured_image, "540x") +
      " 540w, " +
      slate.Image.getSizedImageUrl(data.featured_image, "720x") +
      " 720w, " +
      slate.Image.getSizedImageUrl(data.featured_image, "900x") +
      ' 900w" alt="' +
      data.title +
      '" class="img-fluid lazyload" />';
  } else {
    productHTML += svgPlaceholder;
  }
  productHTML += "</a>";
  productHTML += "</div>";
  productHTML += '<div class="product-details">';
  productHTML +=
    '<a href="/products/' + data.handle + '" title="' + data.title + '">';
  productHTML += '<h3 class="product-title">' + data.title + "</h3>";
  //productHTML += '<p>MG IS THROWING THIS HERE TO TEST</p>';
  //productHTML += '<div class="product-review-stars">';
  //productHTML += '</div>';
  productHTML +=
    '<span class="product-price-label">' + priceLabelText + "</span>";
  productHTML +=
    '<span class="product-price"><span class="money">' +
    productPrice +
    "</span></span>";
  productHTML += '<span class="btn btn-primary">' + btnText + "</span>";
  productHTML += "</a>";
  productHTML += "</div>";
  productHTML += "</div>";
  var trustPilotRelatedProdsCarousel = '{% render \'trustpilot-product\', product_sku: allSKUs, widget_width: \'100%\' %}';

  $(outputLocation).find(".featured-products-slick").append(productHTML);
  //$(outputLocation).find(".product-review-stars").append(trustPilotRelatedProdsCarousel);
}

/*
BG: persistentCheck: The idea being to constantly check (or persistently check) if the target exists, if it does, pass in an additional function that will trigger once condition is true. If condition is never true, have a timeoutTime to stop checking. 
*/
function persistentCheck(
  target,
  targetValue,
  paramFunction,
  paramTarget,
  timeoutTime
) {
  //console.log('persistentCheckFunction');
  var checkExist = setInterval(function () {
    //console.log('Persistently checking for: '+target);
    //keep checking to see if condition is true

    if ($(target).length > targetValue) {
      //console.log('condition is true, will no longer check.');
      //check paramFunction is actually a function
      if (typeof paramFunction == "function") {
        paramFunction(paramTarget);
      }
      //clear interval
      clearInterval(checkExist);
    }
  }, 100); // check every 100ms

  setTimeout(function () {
    //console.log('couldn\'t find target or condition wasn\'t true');
    clearInterval(checkExist);
  }, timeoutTime);
}

//BG: Trigger window resize event after window has finished resizing.
$(window).resize(function () {
  if (this.resizeTO) clearTimeout(this.resizeTO);
  this.resizeTO = setTimeout(function () {
    $(this).trigger("resizeEnd");
  }, 500);
});

/* Usage: 
$(window).bind('resizeEnd', function() {
    //do something, window hasn't changed size in 500ms
});
*/

/*BG: To be used with Slick slider, namely Related and Recently Viewed slick. The idea being the track height is applied to the slide item height, so we can keep a consistent height. */
function resizeTrackHeight(target) {
  $(target).find(".slick-slide").css("height", "auto");
  setTimeout(function () {
    var trackHeight = $(target).find(".slick-track").height();
    $(target)
      .find(".slick-slide")
      .css("height", trackHeight + "px");
  }, 2000);
}

//Create Cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

//Get cookie value
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

//Delete cookie
function eraseCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}

//BG: JavaScript method of getting the URL Parameter
function getUrlParameter(parameter, url) {
  if (!url) {
    url = window.location.href;
  }

  parameter = parameter.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?|&]" + parameter.toLowerCase() + "=([^&#]*)");
  var results = regex.exec("?" + url.toLowerCase().split("?")[1]);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        //$(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).addClass('variant-available');
        $(selectors.addToCart, this.$container).removeClass('variant-not-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).addClass('variant-not-available');
        $(selectors.addToCart, this.$container).removeClass('variant-available');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
	});

  /*======================================
  Setting Cookie if redirected
  ======================================*/

  function uk_store_redirect() {
    $('.js-button-store-redirect').on('click', function(){
      geoSetCookie("cookieGaradyStorePreferenceThree", "UK", 365);
      geoSetCookie("cookieGaradryStayOnStoreThree", "UK", 365);
    })
  }

  uk_store_redirect();

//BG: Init slickSlider for Related Products.
function relatedSlickSlider(target) {
    $(target).slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows:true,
        dots: false,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
            },
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots:false
            }
            }
        ]
    });

    //resizeTrackHeight(target);

    $(window).on('resize',function() {
        //resizeTrackHeight(target);
    });
}


//BG: Make the call to the related products API
function relatedProductsAPI() {
var productID = $('.featured-products.related-products').attr('data-product-id');

    if (productID) { 

    //Make the JSON request to the recommendations API, pass over the current product ID.
    $.getJSON('/recommendations/products.json?product_id='+productID+'&limit=8', function(data) {
        //for each product in the API Response, pass over to the output function.
        $.each(data.products,function(i, product) {
            //BG: outputProduct function used in settings/common.js. It's basic styling.
            outputProduct(product,'.featured-products.related-products');
            var increment = i + 1;

            //BG: if we've cycled through all products, trigger the slickInit
            if (data.products.length == increment) {
                //persistentCheck function in setting/common.js
                persistentCheck('.featured-products.related-products .featured-product',4,relatedSlickSlider,'.featured-products.related-products .featured-products-slick',5000);
            }
        });
    });

    }
}
  

//BG: if variant parameter is available in the URL, change the selection based on this.
function changeProductByVariantID() {
	var variantID = getUrlParameter('variant');
	//console.log(variant);

    if (variantID) {
		$('.swatch [data-variant-id="'+variantID+'"]').find('input[type="radio"]').prop("checked", true);
		//console.log('test');
    }
}

//BG: Intended to work with the 'back in stock' app. Trigger via button
function notifyApp() {
  var soldOutBtn = $('.btn-add-to-cart.variant-not-available'),
      notifyBtn = $('.BIS_trigger');

      soldOutBtn.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger via soldout size label
function notifyAppTwo() {
  var soldOutLabel = $('.soldout > label'),
      notifyBtn = $('.BIS_trigger');

      soldOutLabel.click(function(e){
        e.preventDefault();  
        notifyBtn.click();
      });
}

//BG: Intended to work with the 'back in stock' app. Trigger when all sizes are soldout
function notifyNoSizes() {
  if (!$('.swatch-element').hasClass('available')) {
    $('.BIS_trigger').click();
  }
}
	
  
  //Accordion Functionality.
function accordionToggle() {
	var accordionTitle = $('.accordion-title');
	
	$('.accordion-item.active .accordion-content').show();
	
	accordionTitle.click(function(){
		if ($(this).parent('.accordion-item').hasClass('active')) {
			$(this).parent('.accordion-item').removeClass('active');
			$(this).next('.accordion-content').slideUp();
		} else {
			
			$('.accordion-item').removeClass('active');
			$('.accordion-content').slideUp();
			
			$(this).parent('.accordion-item').addClass('active');
			$(this).next('.accordion-content').slideDown();
		}
	})
}

function sizeguideSelect() {
	var sizeTabs = $('.size-guide-frame .size-tabs li a'),
		sizeSelect = $('.size-guide-frame .size-tabs-select select'),
		sizeTable = $('.size-guide-frame table');

	$(sizeTabs).click(function(e){
		e.preventDefault();
		var tableOption = $(this).attr('data-option');

		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$(sizeSelect).val(tableOption).change();

		$(this).parent('li').addClass('active');
		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');
	});

	$(sizeSelect).on('change', function(){
		var tableOption = $(this).val();
		
		$(sizeTable).removeClass('active');
		$(sizeTabs).parent('li').removeClass('active');

		$('.size-guide-frame .size-tabs li a[data-option="'+tableOption+'"]').parent('li').addClass('active');

		$('.size-guide-frame table[data-table="'+tableOption+'"]').addClass('active');

	});
}

function sizeguideModal() {
    var closeIcon = $('.size-guide-frame .size-guide-close'),
		sizeguideOverlay = $('.size-guide-overlay'),
		sizeguideFrame = $('.size-guide-frame'),
		sizeguideOpen = $('.template-product .size-guide');

    $(closeIcon).click(function(){
        $(sizeguideFrame).removeClass('active');
        $(sizeguideOverlay).removeClass('active');
    })

    $(sizeguideOpen).click(function(){
        $(sizeguideFrame).addClass('active');
        $(sizeguideOverlay).addClass('active');
    })
}

//Checks to see if any colours are in the related_colours element, if there are then show the main colours div.
function colourChecker() {
  var productColoursContainer = document.querySelector('.product-related-colours');
  var productColours = document.querySelectorAll('.product-related-colours li');

  if (productColours.length > 0) {
    //Shows main container
    productColoursContainer.classList.add('active');
  }
}

function productSlick() {
    $('.product-detail-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow:slickPrevArrow,
        nextArrow:slickNextArrow,
        arrows: true,
        dots: false,
        asNavFor: '.product-detail-thumbnails',
        responsive: [
           {
               breakpoint: 992,
               settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1,
               }
           }
       ]
   });
   
   $('.product-detail-thumbnails').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: slickPrevArrow,
        nextArrow: slickNextArrow,
        asNavFor: '.product-detail-images',
        focusOnSelect: true,
        responsive: [
           {
               breakpoint: 992,
               settings: {
                   slidesToShow: 3
               }
           }
       ]
   });
}

function whatsappIcon() {
    //if user on mobile
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        $('.social-sharing-products .whatsapp').removeClass('d-none');
    }
}

function productTabs() {
    var tabs = $('.product-tabs-container .tabs-wrapper .tabs a'),
        inlineTabs = $('.product-tabs-container .product-tab-container .product-tab-title'),
        tabsContent = $('.product-tabs-container .product-tab-container');

        tabs.on('click', function(){
            tabs.removeClass('is-active');
            $(this).addClass('is-active');

            var tabName = $(this).attr('href').replace("#","");

            tabsContent.removeClass('is-active');
            $('.product-tabs-container .product-tab-container[data-tab-name="'+tabName+'"]').addClass('is-active');

        });

        inlineTabs.on('click', function(){
            inlineTabs.parent('.product-tab-container').removeClass('is-active');
            $(this).parent('.product-tab-container').addClass('is-active');
        });
}

//BG: Product Image Zoom Options
function imageZoom() {
    $('.image-zoom').ezPlus({
        zoomType: 'lens',
        //lensShape: 'round',
        lensSize: 350,
        zoomWindowFadeIn: 500,
        zoomWindowFadeOut: 500,
        lensFadeIn: 500,
        lensFadeOut: 500,
        //scrollZoom: true,
        //zoomWindowPosition: 1,
        borderColour: '#D8D8D8'
    });
}

/* BG: Update eKomi Star Rating on variant change

UPDATE, can't get it to refire on select....booooo */
function eKomiVariantStarRating(variant_sku) {

    if (variant_sku) {
    var widgetContainer = $('.ekomi-review-stars'),
        widgetToken = $('.ekomi-review-stars').attr('data-widget-token'),
        widgetStore = $('.ekomi-review-stars').attr('data-widget-store'),
        widgetLanguage = $('.ekomi-review-stars').attr('data-widget-language')
        widgetCode = "<div id='widget-container' class='data-ekomi-emp ekomi-widget-container ekomi-widget-"+widgetToken+"'></div><div id='ekomi-product-widget-identifier' class='prod-data-emp'  style='visibility: hidden; display:none;'>"+variant_sku+"</div><script type='text/javascript'>(function (w) {w['_ekomiWidgetsServerUrl'] = (document.location.protocol == 'https:' ? 'https:' : 'http:') + '//widgets.ekomi.com';w['_customerId'] = "+widgetStore+";w['_ekomiDraftMode'] = true;w['_language'] = '"+widgetLanguage+"';if(typeof(w['_ekomiWidgetTokens']) !== 'undefined'){w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = '"+widgetToken+"';} else {w['_ekomiWidgetTokens'] = new Array('"+widgetToken+"');}if(typeof(ekomiWidgetJs) == 'undefined') {ekomiWidgetJs = true;var scr = document.createElement('script');scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';var head = document.getElementsByTagName('head')[0];head.appendChild(scr);}})(window);</script>";

        widgetContainer.html(widgetCode);
    } else {
        console.log('need a variant SKU');
    }
}

/*
BG: When the user changes the variant option, we need to update the following areas:
    -   Price
    -   Price without Tax
    -   Availability
    -   Sku
    -   eKomi Stars & Reviews
*/

function variantSelector() {

    var variantSelect = $('.product-selector-and-quantity .single-option-selector'),
        formVariantSelect = $('select[name="id"]');

    //on change, get the data, and then output the results.
    variantSelect.on('change',function(){



        var variantPrice = $(this).find(':selected').attr('data-price'),
            variantPriceWithoutTax = $(this).find(':selected').attr('data-price-without-tax'),
            variantAvailable = $(this).find(':selected').attr('data-available'),
            variantQty = $(this).find(':selected').attr('data-qty'),
            variantID = $(this).find(':selected').attr('value'),
            variantSku = $(this).find(':selected').attr('data-sku'),
            labelInStock = $('.product-availability').attr('data-in-stock'),
            labelOutOfStock = $('.product-availability').attr('data-out-of-stock');

        
        var variantCompareAtPrice = $(this).find(':selected').attr('data-compare-at-price');
        
        //remove the compare at price, for each change
        $('.product-detail-price .product-price-original').remove();

        //if it exists for this variant, add it back in.
        if (variantCompareAtPrice) {
            $('.product-detail-price > .money').after(' <span class="product-price-original" data-compare-price><span class="money">'+variantCompareAtPrice+'</span></span>');
        }
        
        $('.product-detail-price > .money').text(variantPrice);
        $('.product-detail-price-without-tax').html(variantPriceWithoutTax);

        //$('.product-detail-price .money').text(variantPrice);
        //$('.product-detail-price-without-tax').html(variantPriceWithoutTax);

        formVariantSelect.find('option[value="'+variantID+'"]').prop('selected',true);

        // Get the selected variantID
        var selectedVariantID = $(this).find(':selected').attr('value');

        // Hide all shipping--message divs
        $('.shipping--message').hide();

        // Show the shipping--message div with matching variantID
        $('.shipping--message.' + selectedVariantID).show();
      
        //Update SKU (Product Part)
        $('.product-sku .value').text(variantSku);

        //BG: remove the in and out of stock messages
        $('.product-availability .in-stock').remove();
        $('.product-availability .out-of-stock').remove();
        $('.btn-primary span').remove();
      
        //BG: Update eKomi Star Rating
        //eKomiVariantStarRating(variantSku);

        //apply the new availability.
        if (variantQty > 0) {
            $('.product-availability').append('<span class="in-stock"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>' + labelInStock + '</span>');
            $('.btn-primary').append('<span data-add-to-cart-text="">ADD TO BASKET</span>');
            $('.ot-estimated-shipping').show();
            $('.shipping--message').hide();
        } else {
            $('.product-availability').append('<span class="out-of-stock"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path></svg>' + labelOutOfStock + '</span>');
            $('.btn-primary').append('<span data-add-to-cart-text="">Pre Order</span>');
            $('.ot-estimated-shipping').hide();
            $('.shipping--message.' + selectedVariantID).show(); 
        }

        $('.paypal-container').removeClass('active');
        $('.paypal-container[data-sku='+ variantSku +']').addClass('active');
    })	

}





/*BG: When clicking the star rating on the product page, scroll down to the reviews widget (if visible) */
function scrollToReviews() {

    var productStars = $('.product-review-stars-container'),
        productReview = $('.ekomi-product-review');
        
    //if allow the scroll down action if the widget is visible    
    if ($('.ekomi-product-review .ekomi-widget-container').css('display') != 'none') {
        //console.log('its visible');
        productStars.on('click', function(){
            //console.log('clicked');
            $('html, body').animate({
                scrollTop: productReview.offset().top
            }, 2000);
        });

    //if not visible, then hide the container 
    } else {
        //console.log('its not visible');
        $('.ekomi-product-review').addClass('d-none');
    }

}

function productQuantityFunc() {

    var product = $('.product-quantity-holder');
            
    var quantitySelect = product.find('.product-quantity'),
    plusQuantity = product.find('[data-quantity="plus"]'),
    quantityInput = product.find('input[name="quantity"]'),
    maxQuantity = quantitySelect.attr('data-max-quantity'),
    minusQuantity = product.find('[data-quantity="minus"]');

    $(plusQuantity).off('click').on('click', function(e) {
        e.preventDefault();
        var currentVal = parseInt($(quantityInput).val()) + 1;

        if (!isNaN(currentVal)) {
            if (currentVal <= maxQuantity) {
                $(quantityInput).val(currentVal);
                var inputAmount = $(quantityInput).val();
                $(".product__details .product-quantity .prod-quantity").attr('value', inputAmount);

                if (currentVal == maxQuantity) {
                  plusQuantity.addClass('greyed');
                }
            }

            if (minusQuantity.hasClass('greyed')) {
                minusQuantity.removeClass('greyed');
            }
        } 
    });

    $(minusQuantity).off('click').on('click', function(e) {
        e.preventDefault();
        var currentVal = parseInt($(quantityInput).val()) - 1;

        if (!isNaN(currentVal) && currentVal >= 1) {
            $(quantityInput).val(currentVal);
            var inputAmount = $(quantityInput).val();
            $(".product__details .product-quantity .prod-quantity").attr('value', inputAmount);

            if (currentVal == 1) {
              plusQuantity.addClass('greyed');
              $(quantityInput).val(1);
              var inputAmount = $(quantityInput).val();
              minusQuantity.addClass('greyed');
            }
        }

        if (plusQuantity.hasClass('greyed')){
            plusQuantity.removeClass('greyed');
        }

    });
}
function headroomAddToCart() {
	// grab an element
	var addtocartBtn = document.querySelector(".product-add-to-basket");

  if (typeof(addtocartBtn) != 'undefined' && addtocartBtn != null) {
      // construct an instance of Headroom, passing the element
      var headroomHeader  = new Headroom(addtocartBtn, {
        "offset": 1100
      });
      // initialise
      headroomHeader.init(); 
  }
}

//cartQuantity();

function instructionVideoPopup() {
  $('.instruction-video-toggle').on('click', function(e) {
      $('.instruction-video-popup').addClass('active');
      $('.instruction-video-overlay').addClass('active');
  });

  $('.instruction-video-popup .close-button').on('click', function(e) {
      $('.instruction-video-popup').removeClass('active');
      $('.instruction-video-overlay').removeClass('active');
  });
}

//BG: Only run on Product Page.
if ($('body.template-product').length) {

    changeProductByVariantID();
  	sizeguideSelect();
    sizeguideModal();
    relatedProductsAPI();
    productSlick();
    whatsappIcon();
    variantSelector();
    headroomAddToCart();
    instructionVideoPopup();

    setTimeout(function(){
        scrollToReviews();
    ; }, 2000);
    productQuantityFunc();

    //BG: Discussed with client, and based on the already large images by standard, we decided it best to remove the image zoom. I've commented out the below function, and also the plugin code from the vendor.js
    //imageZoom();
    
    //BG: App related functions for Product Page
    persistentCheck('.BIS_trigger',0,notifyApp,'nothing',10000);
    persistentCheck('.BIS_trigger',0,notifyAppTwo,'nothing',10000);

  }

  accordionToggle();
  productTabs();

  return Product;
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
	  
	if ($(this).hasClass('address-new-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-new-secondary')) {
		$('.address-new-primary').removeClass('hide');
	}
	  
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
	  
	if ($(this).hasClass('address-edit-primary')) {
		$(this).addClass('hide');
	}
	  
	if ($(this).hasClass('address-edit-secondary')) {
		$('.address-edit-primary').removeClass('hide');
	}
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



/*BG: Native Sort By functionality. */
function nativeSortBy() {
    //get the paramater value (if present)
    var sortByParam = getUrlParameter('sort_by'),
        //the current url minus parameters
        currentURL = location.protocol + '//' + location.host + location.pathname,
        //the select field
        sortBySelect = $('#sort-by-container select');

        //when the select field changes, get the current value and send the user to the same page with the parameter attached.    
        sortBySelect.on('change',function() {
            var selectedValue = $(this).find(':selected').attr('value');
            window.location.href = currentURL + '?sort_by=' + selectedValue;
        });

    //if parameter exists update select field to show which sort by has been applied.
    if (sortByParam) {
        $('#sort-by-container select option[value='+sortByParam+']').attr('selected','selected');
    }
}

/*BG: Native Filter Title - When clicking on the title, expand the filter options. */
function nativeFilterTitle() {
    var filterTitle = $('.collection-native-filters .collection-native-filters-title'),
        filterOptions = $('.collection-native-filters > .row');

    filterTitle.on('click', function() {
        $(this).toggleClass('active');
        filterOptions.toggleClass('active');
    }); 
}


function collectionReadMore() {
	var readmoreBtn = $('.collection-read-more'),
		collectionDescription = $('.collection-description .rte'),
		collectionDescriptionHeight = collectionDescription.height();
		//collectionNav = $('.collection-header .collection-sub-nav'),
		//collectionNavHeight = collectionNav.height();

		readmoreBtn.off('click').on('click', function(e){

		if (readmoreBtn.hasClass('active')) {

			// collectionNav.animate({
			// 	height: collectionNavHeight
			// }, 1000);

			collectionDescription.removeClass('active');

			collectionDescription.animate({
				height: collectionDescriptionHeight
			}, 1000, function(){
				readmoreBtn.removeClass('active');
			});

			readmoreBtn.text('Read More');

		} else {

			// collectionNav.animate({
			// 	height: collectionNav.get(0).scrollHeight
			// }, 1000, function(){
			// 	$(this).height('auto');
			// });

			collectionDescription.addClass('active');

			collectionDescription.animate({
				height: collectionDescription.get(0).scrollHeight
			}, 1000, function(){
				$(this).height('auto');
				readmoreBtn.addClass('active');
			});

			readmoreBtn.text('Read Less');

		}

	});
}

//BG: Collection toggle only appears on mobile, and it's defaulted listing view is two products per row.
function collectionView() {
    var savedCollectionView = localStorage.getItem('collectionView'),
        setCollectionView = $('#bc-sf-filter-products'),
        collectionToggle = $('.collection-grid li');

    //BG: if collection view localstorage exists, lets set it.
    if (savedCollectionView == 'list') {
        setCollectionView.removeClass('grid');
        setCollectionView.addClass(savedCollectionView);
        collectionToggle.removeClass('active');
        $('.collection-grid li.list').addClass('active');
    }

    //on click
    collectionToggle.click(function(){
        collectionToggle.removeClass('active');

        //BG: if selecting two (which is default, simply delete the localstorage item)
        if ($(this).hasClass('grid')) {
            localStorage.removeItem('collectionView');
            $(this).addClass('active');
            setCollectionView.removeClass('list');
            setCollectionView.addClass('grid');
        //BG: if single, set localstage item
        } else {
            localStorage.setItem('collectionView','list');
            $(this).addClass('active');
            setCollectionView.removeClass('grid');
            setCollectionView.addClass('list');
        }
    });
}

function filterToggle() {
	var filterTitle = $('.filter-title'),
		filterSidebar = $('.filter-sidebar');
	
	filterTitle.off('click').on('click', function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			filterSidebar.slideUp();
		} else {
			$(this).addClass('active');
			filterSidebar.slideDown();
		}
	});
}

//BG: For each product, find the related product colour and link to it.
function collectionProductColours() {
	var collectionProducts = $('.collection-listing .product-single');

	//Loop through the product list, and get the productID for each product. The loop through the second list of products, and match them based on the productGroup.
	collectionProducts.each(function(){
	var productID = $(this).attr('data-product-id'),
		productGroup = $('.collection-product-colours li[data-product-id="'+productID+'"]').attr('data-product-group'),
		productGroupCollection = $('.collection-product-colours li[data-product-group="'+productGroup+'"]');

		//Loop through the product grouping, and append the products to their related grouping.
		productGroupCollection.each(function(){
			var thisProductID = $(this).attr('data-product-id'),
				thisProductColour = $(this).attr('data-product-colour'),
				thisProductImage = $(this).attr('data-product-image-large'),
				thisProductImageSecondary = $(this).attr('data-product-image-secondary'),
				thisProductURL = $(this).attr('data-product-url');

				if (thisProductID == productID) {
					thisProductColour = thisProductColour + " primary-product active";
				}

				var list = '<li class="'+thisProductColour+'" data-product-id="'+thisProductID+'" data-product-image="'+thisProductImage+'" data-product-image-secondary="'+thisProductImageSecondary+'" data-product-url="'+thisProductURL+'"></li>';

			//if product has colour....then append it.
			if (thisProductColour) {	
				if (thisProductID == productID) {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').prepend(list);
				} else {
					$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours ul').append(list);
				}
			}

			//if more than one colour, show colours.
			if ($('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours li').length > 1) {
				$('.collection-listing .product-single[data-product-id="'+productID+'"] .product-colours').removeClass('d-none');
			}
		});
	})
}

//BG: used in conjuction with the above function, once the above function has ran, we then need to allow the user to switch between the colours, and show image and update the product link.
function collectionProductColourSwitcher() {
	var productColours = $('.collection-listing .product-colours li'),
		interactionType = "";

	if ($(window).width() <= screenMD) {
		interactionType = "click";
	} else {
		interactionType = "mouseover";
	}

	productColours.on(interactionType, function() {
		var productImage = $(this).attr('data-product-image'),
			productImageSecondary = $(this).attr('data-product-image-secondary'),
			productURL = $(this).attr('data-product-url'),
			productID = $(this).attr('data-product-id'),
			parentProductID = $(this).closest('#product_single').attr('data-product-id'),
			productColours = $(this).closest('#product_single').find('.product-colours li'),
			primaryImage = $(this).closest('#product_single').find('.product-image img'),
			parentProductURL = $(this).closest('#product_single').find('a'),
			quickView = $(this).closest('#product_single').find('.product-quickview span');

			productColours.removeClass('active');
			$(this).addClass('active');

			primaryImage.attr('src', productImage);
			primaryImage.attr('data-second-image', productImageSecondary);
			parentProductURL.attr('href', productURL);
			quickView.attr('data-product-url', productURL);
	});
}

//BG: Changing the method of adding a second image. Rather than loading in the image as default, i'm loading in the URL to the second image, and will load it on hover.
function collectionProductHover() {
	$('.collection-listing .product-single .product-image img').on("mouseenter", function(){
		var firstImage = $(this).attr('data-src'),
			secondImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',secondImage);
			$(this).attr('src',secondImage);
			$(this).attr('data-srcset',secondImage);
			$(this).attr('srcset',secondImage);
			$(this).attr('data-second-image',firstImage);
	});
	$('.collection-listing .product-single .product-image img').on("mouseleave", function(){
		var secondImage = $(this).attr('data-src'),
			firstImage = $(this).attr('data-second-image');
			
			$(this).attr('data-src',firstImage);
			$(this).attr('src',firstImage);
			$(this).attr('data-srcset',firstImage);
			$(this).attr('srcset',firstImage);
			$(this).attr('data-second-image',secondImage);
	});
}

collectionReadMore();
collectionView();
filterToggle();
collectionProductHover();
nativeSortBy();

if ($('body.template-collection').length) {
    nativeFilterTitle();
}
//Update the quantity field on the cart page. Based on plus and minus buttons.
function cartQuantity() {
	var cartQuantity = $('.cart-product-quantity');

	
	cartQuantity.each(function(){
		var quantityUp = $(this).find('.quantity-up'),
			quantityDown = $(this).find('.quantity-down'),
			quantityValue = $(this).find('.cart-item__qty');
		
		
		quantityUp.on('click',function(){

			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal)) {
				quantityValue.val(currentVal + 1);
			}
			$('.btn-cart-update').click();
		});
		quantityDown.on('click',function(){
			var currentVal = parseInt(quantityValue.val());
			if (!isNaN(currentVal) && currentVal > 1) {
				quantityValue.val(currentVal - 1);
			}
			$('.btn-cart-update').click();
		});
		
		quantityValue.bind('input',function() {
			$('.btn-cart-update').click();
		});
	});

}


function cartQuantitySelect() {
	var cartQuantity = $('.product-quantity');

	cartQuantity.each(function(){
		var quantitySelect = $(this).find('.product-quantity-select'),
			quantityValue = $(this).find('.product-quantity-value').attr('value'),
            quantityInput = $(this).find('.product-quantity-value');

		//On initial load, set the dropdown to reflect the current quantity.	
        quantitySelect.find('[value="'+quantityValue+'"]').attr('selected', 'selected').siblings('option').removeAttr('selected');


		// LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
		quantitySelect.on('change', function(){
			var selectedValue = $(this).find(':selected').attr('value');
			var selectedInput = $(this).next();

			$(selectedInput).attr('value', selectedValue);
		});
	});
}

//BG: Check if user has entered a value, and inform the user it's been applied and will confirm if it works on checkout.
function promoCode() {
    var discountFormInputValue = $('.discount-form input[type="text"]').val(),
    promoFeedback = $('.discount-form .promo-feedback'),
    promoFeedbackMessage = $('.discount-form .promo-feedback').attr('data-message');

    if (discountFormInputValue) {
        promoFeedback.removeClass('d-none');
        promoFeedback.slideDown();
        promoFeedback.html('<strong>' + discountFormInputValue + '</strong> '+promoFeedbackMessage);
    }
}

//BG: Capture promo code, and confirm to user.
function capturePromoCode() {
    var discountFormInput = $('.discount-form input[type="text"]'),
        discountFormBtn = $('.discount-form .btn');

    discountFormInput.on('keydown', function(e){
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    });

    discountFormInput.on('keyup', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            promoCode();
        }
    });

    discountFormBtn.on('click', function(e) {
        e.preventDefault();
        promoCode();
    });
}

function headroomCheckout() {
	// grab an element
	var checkoutBtn = document.querySelector(".checkout-mobile");
	// construct an instance of Headroom, passing the element
	var headroomHeader  = new Headroom(checkoutBtn, {
		"offset": 150
	});
	// initialise
	headroomHeader.init(); 
}

//cartQuantity();
if ($('body.template-cart').length) {
	headroomCheckout()
}
cartQuantitySelect();
capturePromoCode(); 
function forgotPassword() {

	var loginForm = $('#CustomerLoginForm'),
		passwordForm = $('#RecoverPasswordForm');

	$('.show-forgot-password').click(function(){
		loginForm.addClass('hide');
		passwordForm.removeClass('hide');
	});

	$('.hide-forgot-password').click(function(){
		loginForm.removeClass('hide');
		passwordForm.addClass('hide');
	});
}

function resetPasswordForm() {
	var formState = $('.reset-password-success')

	if (formState.length) {
		$('#ResetSuccess').removeClass('hide');
	}
}


//BG: Tokyo Laundry want to capture Birthdays.
function birthdayFormat(form) {
    var birthdayField = form.find('#Birthday'),
        birthdayFieldValue = 'Day/Month/Year',
        birthdayDay = form.find('#birthday-day'),
        birthdayDayValue = '',
        birthdayMonth = form.find('#birthday-month'),
        birthdayMonthValue = '',
        birthdayYear = form.find('#birthday-year'),
        birthdayYearValue = '';
    
    function combinedValue() {
        birthdayFieldValue = birthdayDayValue +' '+birthdayMonthValue +' '+ birthdayYearValue;
        birthdayField.val(birthdayFieldValue);
    }    

    birthdayDay.on('change', function(){
        birthdayDayValue = $(this).val();
        combinedValue();
    });

    birthdayMonth.on('change', function(){
        birthdayMonthValue = $(this).val();
        combinedValue();
    });

    birthdayYear.on('change', function(){
        birthdayYearValue = $(this).val();
        combinedValue();
    });
}

//BG: Check to see if the form is valid.
function checkFormValidation(form) {
    var invalidFields = form.find('label.required'),
        invalidFieldsCount = 0,
        validFieldsCount = 0;

    invalidFields.each(function(){
        if ($(this).hasClass('validated')) {
            validFieldsCount++;
        } else {
            invalidFieldsCount++;
        }
    });
    if (invalidFieldsCount === 0) {
        form.removeClass('validation-invalid');
    }

    console.log('invalid count:'+invalidFieldsCount);
    console.log('valid count:' +validFieldsCount);
}

//BG: build error message, what the message contains and where it should output.
function feedbackMessage(field, status, message,form) {
    var messageNoWhitespace = field.replace(/\s/g, ""),
        html = "<div class='ajaxfeedback "+status+" "+messageNoWhitespace+"'>"+message+"</div>";

    //if error messages are already showing, don't show again.
    if ($('.ajaxfeedback.' + messageNoWhitespace).length == 0) {
        form.before(html);
    }
}

function confirmPasswords(form) {
    $('#CreatePassword').on('input', function(){
        var passwordOneValue = $('#PasswordOne').val(),
            passwordTwoValue = $('#CreatePassword').val();

        if (passwordOneValue != passwordTwoValue) {
            $('.ajaxfeedback.Password').remove();
            feedbackMessage('Password','error','Passwords do not match',form);
            $('label.password-required').removeClass('validated');
        } else {
            $('.ajaxfeedback.Password').remove();
            $('label.password-required').addClass('validated');
            feedbackMessage('Password','success','Passwords match',form);
            checkFormValidation(form);
        }
    });  
}


//BG: Check input values
function checkRequiredFields(form) {
    var formFields = form.find('input.required:not(.password-required)'),
        passwordFields = form.find('input.password-required');

    //For each required field....
    formFields.each(function(){
        //on input should detect: paste, right click, deleting text or typing text. 
        $(this).on('input', function(){
            var thisValue = $(this).val(),
                label = $(this).attr('id'),
                labelNoWhitespace = label.replace(/\s/g, "");

            //If the value is greater than 0
            //add valid input classes and remove invalid messages
            if (thisValue.length > 0) {
                $(this).addClass('input-valid');
                $(this).removeClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').addClass('validated')
                $('.ajaxfeedback.'+labelNoWhitespace).remove();
                checkFormValidation(form);
            } else {
                $(this).removeClass('input-valid');
                $(this).addClass('input-invalid');
                $('label[for="' + labelNoWhitespace + '"]').removeClass('validated')
            }
        });
    });

    if (passwordFields.length > 0) {
        confirmPasswords(form);
    }
}

//Highlighted the required fields to the user, and output error message.
function highlightRequiredFields(form) {
    //get list of labels
    var invalidFormLabels = form.find('label.required:not(.validated)'),
        once = 0;

    invalidFormLabels.each(function(){
        if ($(this).hasClass('password-required')) {
            //Run once
            if (once == 0) {
                feedbackMessage('Password','error','<strong>Password</strong> this field is required.',form);
                once++;
            }
        } else {
            var labelValue = $.trim($(this).text());
            feedbackMessage(labelValue,'error','<strong>'+labelValue+'</strong> this field is required.',form)
        }
    })

}

/* 
BG: Basic form validation intended for the registration form.
*/
function registrationFormValidation() {
    var registrationForm = $('#create_customer');

    checkRequiredFields(registrationForm);
    //birthdayFormat(registrationForm);

    registrationForm.on('submit', function(e) {
        //If class is present, don't submit form.
        if ($(this).hasClass('validation-invalid')) {
            e.preventDefault();
            highlightRequiredFields(registrationForm);
        } 
    });
}

function addressEditDelete() {

    //Delete Address, confirm user action.    
    $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
    });
    
    //Toggle edit address
    $('.edit-address').on('click', function() {
        var formId = $(this).attr('data-form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
          
        if ($(this).hasClass('address-edit-primary')) {
            $(this).addClass('hide');
        }
          
        if ($(this).hasClass('address-edit-secondary')) {
            $('.address-edit-primary').removeClass('hide');
        }
    });
}

function accountNavigation() {
    var accountSidebarTitle = $('.account-sidebar h3'),
        accountSidebarNavigation = $('.account-sidebar-navigation');

   accountSidebarTitle.on('click', function(){
        accountSidebarTitle.toggleClass('active');
        accountSidebarNavigation.toggleClass('active');
   });   
}

addressEditDelete();
resetPasswordForm();
forgotPassword();
registrationFormValidation();
accountNavigation();
function sidebarLinks() {
	var sidebarTitle = $('.sidebar-title'),
		sidebarContent = $('.sidebar-content');

	if ($(window).width() <= screenMD) {
		
		sidebarTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.sidebar-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.sidebar-content').slideDown();
			}
		});
		
	} else {
		sidebarTitle.off('click');
		sidebarContent.css('display', '');
	}
}

/*BG: Used on the Meet The Team page template */
function meetTheTeamPopup() {
    if ($('.team-member-listing').length > 0) {
        var teamListing = $('.team-member-listing');

        teamListing.each(function(){
            //Define the variables
            var memberImage = $(this).find('.team-member-photo').attr('data-image-url'),
                memberName = $(this).find('.team-member-detail').attr('data-member-name'),
                memberRole = $(this).find('.team-member-detail').attr('data-job-role'),
                memberSubTitleOne = $(this).find('.team-member-detail').attr('data-sub-title-one'),
                memberSubContentOne = $(this).find('.team-member-detail').attr('data-sub-content-one'),
                memberSubTitleTwo = $(this).find('.team-member-detail').attr('data-sub-title-two'),
                memberSubContentTwo = $(this).find('.team-member-detail').attr('data-sub-content-two'),
                ctaButton = $(this).find('.btn.btn-secondary');


                ctaButton.on('click', function(){
                    $('.team-member-popup .team-member-photo').css('background-image','url('+memberImage+')');
                    $('.team-member-popup .team-member-details h3').text(memberName);
                    $('.team-member-popup .team-member-details .job-role').text(memberRole);
                    $('.team-member-popup .team-member-bio.one h4').text(memberSubTitleOne);
                    $('.team-member-popup .team-member-bio.one .rte').html(memberSubContentOne);
                    $('.team-member-popup .team-member-bio.two h4').html(memberSubTitleTwo);
                    $('.team-member-popup .team-member-bio.two .rte').html(memberSubContentTwo);

                    $('.team-member-popup').addClass('active');
                    $('.team-member-overlay').addClass('active');
                });
        });


        $('.team-member-popup .close-modal,.team-member-overlay').on('click', function(){
            $('.team-member-overlay').removeClass('active');
            $('.team-member-popup').removeClass('active');

            $('.team-member-popup .team-member-photo').css('background-image','');
            $('.team-member-popup .team-member-details h3').text('');
            $('.team-member-popup .team-member-details .job-role').text('');
            $('.team-member-popup .team-member-bio.one h4').text('');
            $('.team-member-popup .team-member-bio.one .rte').html('');
            $('.team-member-popup .team-member-bio.two h4').html('');
            $('.team-member-popup .team-member-bio.two .rte').html('');

        });

    }
}

/*BG: This function will add the TH as a data attribute on each row */
/* UPDATE: Not possible due to the complex nature of the table, some cells merge with one another so not that simple */
function tableDataAttr(table) {
    var heading = $(table).find('th'),
        tableRow = $(table).find('tr');

    var headerArray = [];

    heading.each(function(i){
        //i++;
        var headerValue = $(this).text();
        //console.log(headerValue + ': ' +i);
        headerArray.push(headerValue);

        //$(table).find('tr td:nth-child('+i+')').attr('data-column-name',headerValue);
    });

    tableRow.each(function(i){
        var tdCount = $(this).find('td');
        console.log(tdCount.length);
        //var tdValue = $(this).text();
    });

    //console.log(headerArray);
    //console.log(headerArray[0]);


}

/*BG: Wrap the table in a div that we can style */
function tableWrap() {
    var tables = $('body.template-page .generic-template.rte table');

    if (tables) {
        tables.each(function(){
            var table = $(this);
            $(this).wrap('<div class="rte-table"></div>');

            //tableDataAttr(table);
        })
    }
}

function populateBuyersGuideSidebar() {

    var sidebar = $('.advanced-page-sidebar');

    if (sidebar.length) {
        var sideBarList = $('.advanced-page-sidebar ul');

        $("h2").each(function() {
            var itemID =  $(this).text().replaceAll(' ', '-');
            itemID = itemID.replaceAll('?', '');
            var itemIDFormatted = itemID.toLowerCase();

            sideBarList.append('<li><a data-id="'+ itemIDFormatted +'">' + $(this).text() + '</a></li>');
        });
    }

    buyersGuideScrollToElement();
}

function buyersGuideScrollToElement() {

    $('.advanced-page-sidebar ul li a').click(function() {
        var id = $(this).attr('data-id');

        $('html, body').animate({
            scrollTop: $('#'+id).offset().top
        }, 1000);
    });
}

sidebarLinks();
meetTheTeamPopup();
tableWrap();
populateBuyersGuideSidebar();

$(window).on('resize',function() {
    sidebarLinks();
});
function categoryToggle() {
	var categoryTitle = $('.categories-title'),
		categorySidebar = $('.categories-links');
	
	if ($(window).width() <= screenLG) {
		
		categoryTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				categorySidebar.slideUp();
			} else {
				$(this).addClass('active');
				categorySidebar.slideDown();
			}
		});
		
	} else {
		categoryTitle.off('click');
		categorySidebar.css('display', '');
	}
}

function returnToBlog() {
	var blogTags = $('.blog-tags li a');

	if ($(blogTags).hasClass('active')) {
		$('.return-to-blog').removeClass('d-none');
	}
}

//categoryToggle();
returnToBlog();

$(window).on('resize',function() {
    //categoryToggle();
});
// Used with sections/header-text-features.liquid
function textFeaturesSlick() {	
	$slick_slider = $('.text-features-slick');
	slicksettings = {
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		responsive: [
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 2
			}
		  },
		  {
			breakpoint: 576,
			settings: {
			  slidesToShow: 1
			}
		  }
		]
	}
	  
	if ($(window).width() < screenLG) {
		$slick_slider.slick(slicksettings);
	}
  
	// reslick only if it's not slick()
	$(window).on('resize', function() {
	   if ($(window).width() > screenLG) {
	 	if ($slick_slider.hasClass('slick-initialized')) {
	 	  $slick_slider.slick('unslick');
	 	}
	 	return
	   } else {
	 	  if (!$slick_slider.hasClass('slick-initialized')) {
	 		return $slick_slider.slick(slicksettings);
	 	  }
	   }
	});
}

$(document).ready(function() {	
    //textFeaturesSlick();
});
//Open and close the mobile Search
function siteSearch() {
	var searchIcon = $('#site-header .header-search-mobile'),
		searchBar = $('#site-header .search-bar');

	searchIcon.click(function(){
		if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            searchBar.slideUp();
		} else {
            $(this).addClass('active');
			searchBar.slideDown();
            searchBar.find('input').focus();
		}
	});
}

function siteSearchInput() {
    var searchInput = $('.site-search input[type="search"]'),
        searchSubmit = $('.site-search button[type="submit"]');

        searchInput.focusin(function(){  
            searchSubmit.addClass('active');  
        }).focusout(function(){  
            searchSubmit.removeClass('active');  
        });    
}

//Toggle open and close of mobile navigation
function mobileNavigationMenuToggle() {
	var menuIcon = $('#site-header .header-mobile-menu'),
		menu = $('#site-navigation'),
		overlay = $('.nav-overlay');

	menuIcon.click(function(){
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			menu.removeClass('active');
			overlay.removeClass('active');
			$('html').removeClass('nav-open');
			$('body').removeClass('nav-push');

		} else {
			$(this).addClass('active');
			menu.addClass('active');
			overlay.addClass('active');
			$('html').addClass('nav-open');
			$('body').addClass('nav-push');
		}
	});

	overlay.click(function() {
		$(this).removeClass('active');
		menu.removeClass('active');
		menuIcon.removeClass('active');
		$('body').removeClass('nav-push');
		$('html').removeClass('nav-open');
	})
}

//Toggle open and close of the individual links within the navigation.
function mobileNavigation() {
	var parentLink = $('#site-navigation .has-child > a'),
		secondaryLink = $('#site-navigation .sub-menu-title'),
        primaryNavigation = $('#site-navigation .top-level');
        
    //BG: Two Tier Navigaton    
    var twoTierParentLink = $('#site-navigation .two-tier-navigation li.has-children > a');
	
	if ($(window).width() <= screenLG) {
		//console.log('screenSM and Lower');
		
		//unbind and bind click action - can cause issues when resizing browser
		parentLink.off('click').on('click', function(e) {
			//prevent anchor from working.
			e.preventDefault();
			
			//add active class to parent and slide down child menus.
			if ($(this).parent('li').hasClass('active')) {
				$(this).next('.sub-menu-container').slideUp(400, function(){
					$(this).parent('li').removeClass('active');	
				});
			} else {
				parentLink.parent('li').removeClass('active');
				parentLink.next('.sub-menu-container').slideUp();
				$(this).next('.sub-menu-container').slideDown(400, function() {
					$(this).parent('li').addClass('active');
				});
			}
        });
        
        twoTierParentLink.off('click').on('click', function(e) {
            //prevent anchor link from working
            e.preventDefault();

            if ($(this).parent('li').hasClass('active')) {
                $(this).parent('li').removeClass('pre-active');
				$(this).next('.child-menu').slideUp(400, function(){
					$(this).parent('li').removeClass('active');
				});
			} else {
                twoTierParentLink.parent('li').removeClass('active');
                twoTierParentLink.next('.child-menu').slideUp();
                /* BG: the idea with this class is to allow us to animate other elements such as the active, to indicate an active state. The reason I don't apply the active class is because we had issues were if the user double or triple clicked on the link, while the animation was occuring, it would bug out and open and close quickly. */
                $(this).parent('li').addClass('pre-active');
				$(this).next('.child-menu').slideDown(400, function(){
					$(this).parent('li').addClass('active');
				});
			}
        });

		secondaryLink.off('click').on('click', function(e) {
			var link = $(this);
			if ($(this).hasClass('active')) {
				$(this).next('ul').slideUp(400, function(){
					link.removeClass('active');
				});
			} else {
				secondaryLink.removeClass('active').next('ul').slideUp();
				$(this).next('ul').slideDown(400, function(){
					link.addClass('active');
				});
			}
		});

		$('#site-navigation').addClass('transition');
		
	} else {
		parentLink.off('click');
		parentLink.next('.sub-menu').css('display', '');
		secondaryLink.off('click');
		secondaryLink.next('ul').css('display','');
		primaryNavigation.removeClass('d-none');
		
		$('#site-navigation').removeClass('active transition');
		$('.nav-overlay').removeClass('active');
		$('.header-mobile-menu').removeClass('active');
		$('body').removeClass('nav-push');
		//console.log('greater than screenSM');
		
	}
}

function desktopNavigation() {
	var mainNavigation = $('#site-navigation'),
		navOverlay = $('.nav-overlay'),
        parentLink = $('#site-navigation .has-child');
        

    var twoTierParentLink = $('#site-navigation .two-tier-navigation .has-children'); 
	
	if ($(window).width() >= screenLG) {
		//console.log('Screen LG & Greater');
		
		parentLink.on("mouseover", function() {
			$(this).addClass('active');  
			$(this).find('.menu').addClass('active');
			navOverlay.addClass('active');

			//UPDATE
			//BG: for performance reasons, we are now going to load the images within the mega menu when the user hovers on the menu.

			var navigationImages = $(this).find('.sub-menu-image img');
			navigationImages.each(function(){
				var imageURL = $(this).attr('data-image-url')
				if (imageURL) {
					$(this).attr('src',imageURL);
					$(this).removeClass('img-full');
				}
			});
        });
        
        twoTierParentLink.on("mouseover", function() {
            $(this).addClass('active');
            $(this).find('.child-menu').addClass('active');
            navOverlay.addClass('active');
        });
		
		parentLink.on("mouseout", function() {
			$(this).removeClass('active');  
			$(this).find('.menu').removeClass('active');
			navOverlay.removeClass('active');
        });
        
        twoTierParentLink.on("mouseout", function() {
            $(this).removeClass('active');
            $(this).find('.child-menu').removeClass('active');
            navOverlay.removeClass('active');
        });
        
	} else {
		//console.log('Lower than Screen LG');
		mainNavigation.off("mouseover");
		mainNavigation.off("mouseout");
		parentLink.off("mouseover");
		parentLink.off("mouseout");
	}
}

//BG: Move the navigation on desktop
function moveNavigation() {

    var navigationContainer = $('.site-navigation-container'),
        navigation = $('#site-navigation'),
        siteHeader = $('#site-header');

	if ($(window).width() <= screenLG) {
        siteHeader.after(navigation);
	} else {
        navigationContainer.append(navigation);
	}
}

//BG: Move the USP on desktop
function moveUSP() {
    var topHeaderRow =  $('.top-header-row'),
        siteLogo = $('.site-logo'),
        headerActions = $('.header-actions');

    if ($(window).width() <= screenLG) {
        headerActions.insertAfter(siteLogo);
    } else {
        topHeaderRow.append(headerActions);
    }
}

//BG: Because the header is fixed, we need to add padding to ensure nothing is hidden behind the header.
function headSpaceFix() {
	var header = $('#site-header');

    var headerHeight = header.outerHeight(true);
    
    //BG: if NOT the homepage, and the hero element isn't present, then apply padding.
    if (!$('body').hasClass('template-index') && !$('.hero').length > 0) {
        $('body').css('padding-top',headerHeight);
    }

    //BG: Let's also check if the header text features (assurance messages) are visible, if they aren't we need to add a class.

    if (!$('.header-text-features').length > 0) {
        $('#site-navigation').addClass('no-usp');
        $('#site-header').addClass('no-usp');
        $('.nav-overlay').addClass('no-usp');
    }
	
}

function headroom() {
	// grab an element
	var header = document.querySelector("header");
	// construct an instance of Headroom, passing the element
	var headroomHeader  = new Headroom(header, {
		"offset": 150
	});
	// initialise
	headroomHeader.init(); 
}

function countrySelect() {
	var currentCountry = $('.current-country li');

	currentCountry.click(function(){
		$(this).toggleClass('active');
	});
}

$(document).ready(function() {	
    siteSearch();
    mobileNavigationMenuToggle();
    mobileNavigation()
	desktopNavigation();
	headroom();
	headSpaceFix();
	moveNavigation();
    countrySelect();
    moveUSP();
    siteSearchInput();
});

$(window).on('resize',function() {
    mobileNavigation();
	desktopNavigation();
	headSpaceFix();
	//moveNavigation();
});

//BG: When resize event has finished, then trigger the below.
$(window).bind('resizeEnd', function() {
    moveNavigation();
    moveUSP();
});
function footerLinks() {
	var footerTitle = $('footer .footer-title:not(.nocollapse)'),
		footerContent = $('footer .footer-content');

	if ($(window).width() <= screenSM) {
		
		footerTitle.off('click').on('click', function(){
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).next('.footer-content').slideUp();
			} else {
				$(this).addClass('active');
				$(this).next('.footer-content').slideDown();
			}
		});
		
	} else {
		footerTitle.off('click');
		footerContent.css('display', '');
	}
}

footerLinks();

$(window).on('resize',function() {
    footerLinks();
});
function featuredImagesSlick() {
    $('.featured-images-slider-slick').slick({
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow
	});

	var stHeight = $('.featured-images-slider-slick .slick-track').height();
	$('.featured-images-slider-slick .slick-slide').css('height',stHeight + 'px' );
}

featuredImagesSlick();
function featuredProductsSlick() {
    $('body.template-index section.featured-products .featured-products-slick').each(function(){
        $(this).slick({
            lazyLoad: 'ondemand',
            prevArrow: slickPrevArrow,
            nextArrow: slickNextArrow
        });
    });
}

featuredProductsSlick();
function heroSlickInit() {
    $('.hero-slick').each(function(){
        var heroSlick = $(this);
        $(heroSlick).slick({
                prevArrow: slickPrevArrow,
                nextArrow: slickNextArrow
        });
    });
}

heroSlickInit();
function bootstrapSlider() {
    $("#calculator-range-slider").slider({
        selection:'after',
        tooltip: 'hide'
    });

    $('#calculator-range-slider').slider().on('slideStop', function(){
        var sliderValue = $(this).data('slider').getValue();

        $('.visual-cal-products').removeClass('is-active');
        $('.visual-cal-products[data-order="'+sliderValue+'"]').addClass('is-active');
    })
}

bootstrapSlider();
function slickSlider() {
    $('.generic-slick-slider').each(function(){

        $(this).slick({
            prevArrow: slickPrevArrow,
            nextArrow: slickNextArrow
        });


        var target = $(this);

        //resizeTrackHeight(target);

        $(window).on('resize',function() {
            //resizeTrackHeight(target);
        });

    });

}

slickSlider();
function videoModal() {
    $('.video-modal').off().on('click', function(){
        $('.modal-outer-wrapper').addClass('active');
        $('.video-modal-overlay').addClass('active');

        $('.modal-outer-wrapper video').trigger('play');
    });

    $('.hide-modal-toggle').off().on('click', function(){
        $('.modal-toggle').addClass('d-none');
    });

    $('.close-video-modal').off().on('click', function(){
        $('.modal-outer-wrapper').removeClass('active');
        $('.video-modal-overlay').removeClass('active');

        $('.modal-outer-wrapper video').trigger('pause');
        $('.modal-outer-wrapper video').each(function(){
            var vidDOM = $(this)[0];
            vidDOM.currentTime = 0;
        });
    });

}

//MJ: Hide the Video modal section if the relevant cookie exists.
function videoModalCookie() {
    var videoModal = $('.modal-toggle'),
        videoValue = getCookie('video-modal'),
        videoBtn = $('.modal-toggle .hide-modal-toggle');

    console.log('cookieee ' + videoValue);

    if (!videoValue) {
        videoModal.removeClass('d-none');
    }

    videoBtn.on('click', function(){
        videoModal.addClass('d-none');
        setCookie('video-modal','hidden',14);
    });
}

videoModal();
videoModalCookie();
function timelineSlick() {
	$('.timeline-slick').each(function () {
		$($(this)).slick({
			prevArrow: slickPrevArrow,
			nextArrow: slickNextArrow,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 776,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});
}

timelineSlick(); 

function quickviewVariant() {
	var variants = $('.product-quickview-frame .swatch-element'),
		variantInput = $('.product-quickview-frame .product-variant-id');

	$(variants).click(function(){
		var variantID = $(this).attr('data-variant-id');
		$(variants).removeClass('active');
		$(this).addClass('active');

		$(variantInput).attr('value',variantID);
	});

}

function quickviewSlick() {
	$('.product-quickview-frame .product-detail-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots:true,
		prevArrow: slickPrevArrow,
		nextArrow: slickNextArrow,
		arrows: true,
		fade: true,
	});
}

function quickviewAddToBasket() {
	$('.product-quickview-frame .btn-add-to-cart').click(function(){
		
		$('.product-quickview-frame form').submit(function (e) {
			e.preventDefault();
			addToCart($(this));
		});

		setTimeout(function() {
			$('.product-quickview-frame').removeClass('active');
			$('.product-quickview-overlay').removeClass('active');
			$('.product-quickview-frame .product-frame').html('');
		}, 2500);
	});
	
}

function quickView() {

	var quickViewBtn = $('.product-quickview .btn'),
		quickViewFrame = $('.product-quickview-frame'),
		quickViewOverlay = $('.product-quickview-overlay'),
		quickViewClose = $('.product-quickview-frame .frame-close'),
		quickViewProduct = $('.product-quickview-frame .product-frame');

	$(quickViewBtn).on( "click", function() {
		var productURL = $(this).attr('data-product-url'),
			productAvailability = $(this).attr('data-product-availability');

			console.log(productAvailability);

		quickViewFrame.addClass('active');
		quickViewOverlay.addClass('active');
		$('html,body').addClass('quickview-open');

		$.ajax({
			type: 'GET',
			url: productURL + '.json',
			dataType: 'json',
			success: function (data) {

				console.log(data);

				//if compare price (sale price) is available
				var productComparePrice = '';
				if (data.product.variants[0].compare_at_price > data.product.variants[0].price ) {
					productComparePrice = '<span class="product-price-original"><span class="money">' + data.product.variants[0].compare_at_price + '</span></span>';
				}


				//get product variants
				// var productVariants = '';
				// console.log(data.product.options.values);
				// console.log('yup');
				// $.each(data.product.options.values, function (i, variant) {
				// 	console.log('test' +vairant);
				// });

				//get product options (variant names)
				var productOptions = '';
				$.each(data.product.options, function (i, option) {
					
					//get product variants
					var productVariants = ''
					//loop through each variant
					$.each(option.values, function(i,variant) {

						var firstItem = '';
						if (i == 0) {
							firstItem = 'active';
						}

						productVariants += '<div data-value="'+ data.product.variants[i].title+'" data-variant-id="'+data.product.variants[i].id+'" class="swatch-element '+firstItem+'">'+data.product.variants[i].title+'</div>';
					});

					productOptions += '<div class="swatch swatch-'+option.name.toLowerCase()+'">' +
										'<div class="swatch-header">' +
											'Select a ' + option.name + '' +
										'</div>' +
										productVariants +	
									  '</div>'
				});

			
				//get images for products
				var quickviewImages = '';
				$.each(data.product.images, function (i, image) {
					quickviewImages += '<div class="product-image"><img src="'+ image.src +'" class="img-fluid" alt="'+ data.product.title +'"></div>';
				});

				//if product is available, show the available button, if product is sold out, show the sold out option.
				var addToCartButton = '';
				addToCartButton = '<button type="submit" name="add" data-add-to-cart="" class="btn-add-to-cart btn btn-primary mt-3 variant-available"><span data-add-to-cart-text="">Add to Basket</span></button>'; 

				

				//Build Markup output
var quickviewHTML = '<div class="container product-detail-container quickview-product-details">' +
					'<div class="row align-items-center">' +
					'<div class="col-12 mb-3 mb-md-0">' +
						'<div class="product-detail-images">' +
						quickviewImages + 
						'</div>' +  
					'</div><!-- Col - Image -->' +

					'<div class="col-12">' +
						'<h1 class="product-title text-center"><a href="/products/'+ data.product.handle+'">'+ data.product.title +'</a></h1>' + 
						'<div class="row align-items-sm-center text-center">' +
						'<div class="col-12">' + 
							'<div class="product-detail-price-wrapper">' +
							'<span class="product-detail-price">' +
								'<span class="money">'+ data.product.variants[0].price + '</span>' +
							'</span>' +
							productComparePrice +
							'<form method="post" action="/cart/add">' +
							'<input min="1" type="number" id="quantity" name="quantity" value="1" class="d-none" />' +
								productOptions +
							'<input type="hidden" name="id" class="product-variant-id" value="'+ data.product.variants[0].id + '" />' +	
							addToCartButton +	
							'</form>' +
							'<a class="d-block text-align-center mt-3" href="/products/'+data.product.handle+'">More details</a>' + 
						'</div><!-- col -->' +	
						'</div><!-- row -->' +
					'</div><!-- Col - Details -->' +

					'</div><!-- row -->' +
					'</div><!-- container -->';

					quickViewProduct.html(quickviewHTML);
					quickviewSlick();
					quickviewVariant();
					quickviewAddToBasket();
			}
		});

	});

	$(quickViewClose).click(function(){
		quickViewFrame.removeClass('active');
		quickViewOverlay.removeClass('active');
		quickViewProduct.html('');
		$('html,body').removeClass('quickview-open');
	});
}

quickView();
/**
 * Velstar Ajaxify Cart
 **/
var config = {
  /* Langauge */
  //addToCartBtnText: 		'Add to Basket', //Add to Basket
  //addedToCartBtnText: 	'Added to Basket', //Added to Basket
  //addingToCartBtnText: 	'Adding', //Adding...
  soldOutBtnText: "Sold Out", //Sold Out
  //After adding a product to the cart, how long to wait before it returns to normal?
  returnBtnToNormal: 4000, // milliseconds

  /* Selectors */
  cartTotalSelector: ".mini-cart-total",
  cartRemoveSelector: ".cart-prod-remove",

  /* Icons*/
  successIcon:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>',
  errorIcon:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-times" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>',
  loadingIcon:
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-sync" viewBox="0 0 512 512"><path d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z"></path></svg>',

  /* No need to change this elements. */
  addToCartBtnSelector: ".btn-add-to-cart.variant-available",
  addToCartFormSelector: 'form[action="/cart/add"]',
  shopifyAjaxAddURL: "/cart/add.js",
  shopifyAjaxChangeURL: "/cart/change.js",
  shopifyAjaxUpdateURL: "/cart/update.js",
  shopifyAjaxCartURL: "/cart.js",
};

/* BG: Moved outside of config object so we can use an if statement with fallback language. */
var AddToCartAttr = $(".btn-add-to-cart").attr("data-add-to-cart-text"),
  AddingToCartAttr = $(".btn-add-to-cart").attr("data-adding-to-cart"),
  AddedToCartAttr = $(".btn-add-to-cart").attr("data-added-to-cart");

if (typeof AddToCartAttr !== typeof undefined && AddToCartAttr !== false) {
  var addToCartBtnText = AddToCartAttr;
} else {
  var addToCartBtnText = "Add to Basket";
}

if (
  typeof AddingToCartAttr !== typeof undefined &&
  AddingToCartAttr !== false
) {
  var addingToCartBtnText = AddingToCartAttr;
} else {
  var addingToCartBtnText = "Adding";
}

if (typeof AddedToCartAttr !== typeof undefined && AddedToCartAttr !== false) {
  var addedToCartBtnText = AddedToCartAttr;
} else {
  var addedToCartBtnText = "Added to Basket";
}

//Provide the user Feedback if the Ajax was sucessful or not.
function ajaxFeedback(status, html, $addToCartForm) {
  //$('.ajaxfeedback').remove();
  var feedback = '<p class="ajaxfeedback ' + status + '">' + html + "</p>";

  $addToCartForm.find(config.addToCartBtnSelector).after(feedback);
  $(".ajaxfeedback").slideDown();
}

//BG: Provide the user feedback on the cart template when adjusting quantity / variant.
function ajaxFeedbackCart(status, html, output) {
  $(".ajaxFeedbackCart").remove();
  var feedback =
    '<span class="ajaxFeedbackCart ' + status + '">' + html + "</span>";

  $(output).after(feedback);
}

//Update the button apperance during the various stages. Adding, added, and back to add.
function updateBtnText($button, label, icon) {
  if ($button.children().length) {
    $button.children().each(function () {
      if (icon) {
        if ($.trim($(this).text()) !== "") {
          $(this).html(label + icon);
        }
      } else {
        if ($.trim($(this).text()) !== "") {
          $(this).text(label);
        }
      }
    });
  } else {
    $button.val(label).text(label);
  }
}

//Format the money
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

//BG: Function to update the Cart Dropdown with the newly added product(s)
function updateMiniCartContents() {
  //ajax get request to cart.js
  $.ajax({
    type: "GET",
    url: config.shopifyAjaxCartURL,
    dataType: "json",
    success: function (data) {
      //Debug
      //console.log(data);
      //BG: unique for Yellow Product, their pricing doesn't include tax, so we get the percentage, and multiple by it.
      var taxPercentage = $(".cart-mini-contents").attr("data-percentage-tax");
      if (taxPercentage) {
        taxPercentage = parseFloat(taxPercentage);
        var totalWithTax = data.total_price * taxPercentage;
        totalWithTax = roundToTwo(totalWithTax);
        //Get Cart Total Cost (format it) & Cart Count.
        var cartTotalCost = slate.Currency.formatMoney(
          totalWithTax,
          theme.moneyFormat
        );
      } else {
        //Get Cart Total Cost (format it) & Cart Count.
        var cartTotalCost = slate.Currency.formatMoney(
          data.total_price,
          theme.moneyFormat
        );
      }
      var cartCount = data.item_count;

      //Output cart total
      $(config.cartTotalSelector).text(cartTotalCost);
      // $(config.cartCountSelector).text(cartCount);
      // if (cartCount > 0) {
      //   $(config.cartCountSelector).removeClass("no-items");
      // } else {
      //   $(config.cartCountSelector).addClass("no-items");
      // }

      //MG: This is the message for the bag in the header
      var bagText = $(".header-basket .cart-icon-text").attr("data-cartlang");
      $(".header-basket .cart-icon-text").text(bagText + "(" + cartCount + ")");

      //BG: Small tweak, if count is greater than zero, then remove class on header.
      $('.cart-count').text(cartCount);
      if (cartCount > 0 ) {
        $('.header-basket').addClass('active');
        $('.cart-count').removeClass('no-items');
      } else {
        $('.header-basket').removeClass('active');
        $('.cart-count').addClass('no-items');
      }

      //MG: This is the message in the mini cart header
      var basketHeaderText = $(".cart-header-basket-label").attr(
        "data-basket-label"
      );
      var basketItem = $(".cart-header-basket-label").attr("data-basket-item");
      var basketItems = $(".cart-header-basket-label").attr(
        "data-basket-items"
      );
      //MG: Estalish whether basket header should say item or items
      var itemOrItems;

      if (cartCount == 1) {
        itemOrItems = basketItem;
      } else {
        itemOrItems = basketItems;
      }

      //MG: This is responsible for the mini cart header, and will display the number of items in the cart, ending with Item or Items, dependent on qty
      $(".cart-header .cart-header-basket-label").text(
        basketHeaderText + ": " + cartCount + " " + itemOrItems
      );

      //BG: language
      var quantityText = $(".cart-mini-contents").attr("data-quantity-text"),
        removeText = $(".cart-mini-contents").attr("data-remove-text");

      //remove all items within cart.
      $(".cart-mini-contents .cart-row .cart-item").remove();

      //with the returned data, focus soley on the items. For each item...
      $.each(data.items, function (i, item) {
        //debugging

        var itemID = item.id;
        var itemTitle = item.product_title;
        var itemQuantity = item.quantity;
        var itemVariantId = item.variant_id;
        var itemImage = item.image;
        var itemUrl = item.url;

        var disableMinus = false;

        //BG: unique for Yellow Product, their pricing doesn't include tax, so we get the percentage, and multiple by it.
        var taxPercentage = $(".cart-mini-contents").attr(
          "data-percentage-tax"
        );
        taxPercentage = parseFloat(taxPercentage);

        if (taxPercentage > 0) {
          var itemPriceValue = item.price * taxPercentage;
          var itemPrice = slate.Currency.formatMoney(
            itemPriceValue,
            theme.moneyFormat
          );
        } else {
          var itemPrice = slate.Currency.formatMoney(
            item.price,
            theme.moneyFormat
          );
        }

        if (item.variant_title) {
          var itemVariant = item.variant_title;
        } else {
          var itemVariant = "";
        }

        var buttonMinus = '';
        if (itemQuantity <= 1) {
          buttonMinus = '<button type="button" class="cart-item-quantity-control minus disabled" disabled>-</button>';
        } else {
          buttonMinus = '<button type="button" class="cart-item-quantity-control minus" >-</button>';
        }

/*         var buttonPlus = '';
        if (itemQuantity = variant.inventory_quantity) {
          buttonPlus = '<button type="button" class="cart-item-quantity-control plus disabled" disabled>+</button>';
        } else { buttonPlus = '<button type="button" class="cart-item-quantity-control plus">+</button>';
        } */

        //TODO: Cart rebuild
        //add each product back to mini cart preview.
        $(".cart-mini-contents .cart-row").append(
          '<div class="cart-item" data-cart-item-id="' +
            itemID +
            '"><div class="cart-item-left"><div class="cart-prod-img"><a href="' +
            itemUrl +
            '"><img src="' +
            itemImage +
            '" class="img-fluid"></a></div>' +
            '<div class="cart-prod-qty-mod">' +
            buttonMinus +
            '<input type="number" name="quantity" min="1" class="cart-item-quantity" value="' +
            itemQuantity +
            '" />' +
            '<button type="button" class="cart-item-quantity-control plus">+</button>' +
            "</div>" +
            '</div><div class="cart-item-right"><div class="cart-prod-name"><a href="' +
            itemUrl +
            '">' +
            itemTitle +
            '</a></div><div class="cart-prod-price"><span class="money">' +
            itemPrice +
            '</span></div><div class="cart-prod-variant"><span>' +
            itemVariant +
            '</span></div><div class="cart-prod-quantity"><span class="label">' +
            quantityText +
            ':</span><span class="quantity-value">' +
            itemQuantity +
            '</span></div><div class="cart-prod-remove"><span data-variant-id="' +
            itemVariantId +
            '">' +
            removeText +
            "</span></div></div></div>"
        );
      });

      //re-trigger the remove functionality.
      removeCartItemTrigger();
      quantityControl();
    },
  });
}

//remove product by setting quantity to zero via the data attribute.
function removeItemFromCart(variant_id) {
  //ajax get request to cart.js
  $.ajax({
    type: "POST",
    url: config.shopifyAjaxChangeURL,
    data: "quantity=0&id=" + variant_id,
    dataType: "json",
    success: function (data) {
      //console.log('Remove Item Triggered');

      //Update the cart to reflect new contents.
      updateMiniCartContents();
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
    },
  });
}

//BG: Function will trigger on the cart page if user changes variant
function addItem(variant_id, quantity, old_variant_id) {
  $.ajax({
    type: "POST",
    url: config.shopifyAjaxAddURL,
    data: "quantity=" + quantity + "&id=" + variant_id,
    dataType: "json",
    success: function (data) {
      //console.log("Trigger addItem");
      //console.log({data});
      ajaxFeedbackCart(
        "success",
        "Updated size",
        ".product-title[data-variant-id=" +
          old_variant_id +
          "] .cart-product-variant-select"
      );
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
    },
  });
}

//BG: function can be triggered by Quantity update, or variant update.
function quantityItemChange(
  variant_id,
  value,
  addProduct,
  new_variant_id,
  quantity
) {
  //console.log("quantityItemChange" + variant_id + " " + value);
  //convert string to int
  var variant_id = parseInt(variant_id);

  //ajax get request to cart.js
  $.ajax({
    type: "POST",
    url: config.shopifyAjaxUpdateURL,
    data: "quantity=" + value + "&id=" + variant_id,
    dataType: "json",
    success: function (data) {
      if (addProduct == "add") {
        addItem(new_variant_id, quantity, variant_id);
      } else {
        $.each(data.items, function (index, item) {
          if (variant_id === item.variant_id) {
            if (item.quantity == value) {
              ajaxFeedbackCart(
                "success",
                "Quantity updated",
                ".basket-item[data-variant-id=" +
                  variant_id +
                  "] .product-quantity-select"
              );

              //BG: if the amount has changed, but not to the value the user wanted.
            } else if (item.quantity < value) {
              ajaxFeedbackCart(
                "warning",
                "Quantity Updated to " +
                  item.quantity +
                  ". This is the last remaining amount.",
                ".basket-item[data-variant-id=" +
                  variant_id +
                  "] .product-quantity-select"
              );
            }
            return false;
          }
        });
      }

      var taxPercentage = $(".cart-mini-contents").attr("data-percentage-tax");
      if (taxPercentage) {
        taxPercentage = parseFloat(taxPercentage);
        var totalWithTax = data.total_price * taxPercentage;
        totalWithTax = roundToTwo(totalWithTax);
        //Get Cart Total Cost (format it) & Cart Count.
        var cartTotalCost = slate.Currency.formatMoney(
          totalWithTax,
          theme.moneyFormat
        );
      } else {
        //Update Total Price
        var cartTotalCost = slate.Currency.formatMoney(
          data.total_price,
          theme.moneyFormat
        );
      }

      $(".basket-total-value span").text(cartTotalCost);
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
    },
  });
}

//Define the remove cart item selector, use the .off & .on feature to ensure it works correctly after new contents added to mini cart.
function removeCartItemTrigger() {
  //Remove Item from Cart
  $(config.cartRemoveSelector + " span")
    .off()
    .on("click", function () {
      var varientID = $(this).attr("data-variant-id");

      $(this).parents(".cart-item").slideUp();

      //Pass over to removeItemFromCart Function.
      removeItemFromCart(varientID);
    });
}

function addToCart(form) {
  $(".ajaxfeedback").remove();
  //e.preventDefault();
  var $addToCartForm = form;
  var $addToCartBtn = $addToCartForm.find(
    config.addToCartBtnSelector + ":first-of-type"
  );

  //Adding button stage
  updateBtnText($addToCartBtn, addingToCartBtnText, config.loadingIcon);
  $addToCartBtn.addClass("btn-adding").prop("disabled", true);

  // Add to cart.
  $.ajax({
    url: config.shopifyAjaxAddURL,
    dataType: "json",
    type: "post",
    data: $addToCartForm.serialize(),
    success: function (itemData) {
      //Added button stage
      updateBtnText($addToCartBtn, addedToCartBtnText, config.successIcon);
      $addToCartBtn.removeClass("btn-adding").addClass("btn-added");

      //Once added, reset button back to add.
      window.setTimeout(function () {
        $addToCartBtn.prop("disabled", false).removeClass("btn-added");
        updateBtnText($addToCartBtn, addToCartBtnText);
      }, config.returnBtnToNormal);

      updateMiniCartContents();

      window.setTimeout(function () {
        cartDrawToggle();
        //$('.header-basket .cart-icon').addClass('swing animated');
        //$(".header-basket").addClass("hover active");
      }, 1000);

      window.setTimeout(function () {
        //$(".header-basket").removeClass("hover active");
        //$('.header-basket .cart-icon').removeClass('swing animated');
      }, 4000);
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
      if (response.slice(0, 4) === "All ") {
        ajaxFeedback(
          "error",
          response.replace("All 1 ", "All "),
          $addToCartForm
        );
        $addToCartBtn.prop("disabled", false);
        updateBtnText($addToCartBtn, config.soldOutBtnText);
        $addToCartBtn
          .prop("disabled", true)
          .removeClass("btn-adding")
          .removeClass("btn-added");
      } else {
        ajaxFeedback(
          "error",
          '<i class="fa fa-warning"></i> ' + response,
          $addToCartForm
        );
        $addToCartBtn.prop("disabled", false).removeClass("disabled");
        updateBtnText($addToCartBtn, addToCartBtnText);
      }
    },
  });
  return false;
}

//BG: allows the user to update the quantity and/or variant on the cart page.
function cartItemQuantityVariant() {
  var cartItem = $(".basket-item");

  cartItem.each(function () {
    var variantSelect = $(this).find("product-variant-select"),
      variantSelectValueOriginal = "",
      quantitySelect = $(this).find(".product-quantity-select"),
      quantitySelectId = quantitySelect.attr("data-variant-id"),
      quantitySelectValue = quantitySelect.val();

    variantSelect.on("focus", function () {
      variantSelectValueOriginal = $(this).val();
    });

    variantSelect.on("change", function () {
      var variantSelectValue = $(this).val();
      quantitySelectId = quantitySelect.attr(
        "data-variant-id",
        variantSelectValue
      );
      quantityItemChange(
        variantSelectValueOriginal,
        0,
        "add",
        variantSelectValue,
        quantitySelectValue
      );
    });

    quantitySelect.on("change", function () {
      quantitySelectValue = $(this).val();
      quantitySelectId = quantitySelect.attr("data-variant-id");
      quantityItemChange(quantitySelectId, quantitySelectValue);
    });
  });
}

function cartItemQuantityVariantMG() {
  var cartItem = $(".cart-item");

  cartItem.each(function () {
    var variantSelect = $(this).find("product-variant-select"),
      variantSelectValueOriginal = "",
      quantitySelect = $(this).find(".product-quantity-select"),
      quantitySelectId = quantitySelect.attr("data-variant-id"),
      quantitySelectValue = quantitySelect.val();

    variantSelect.on("focus", function () {
      variantSelectValueOriginal = $(this).val();
    });

    variantSelect.on("change", function () {
      var variantSelectValue = $(this).val();
      quantitySelectId = quantitySelect.attr(
        "data-variant-id",
        variantSelectValue
      );
      quantityItemChange(
        variantSelectValueOriginal,
        0,
        "add",
        variantSelectValue,
        quantitySelectValue
      );
    });

    quantitySelect.on("change", function () {
      quantitySelectValue = $(this).val();
      quantitySelectId = quantitySelect.attr("data-variant-id");
      quantityItemChange(quantitySelectId, quantitySelectValue);
    });
  });
}

function newQuantity(variantID, quantity) {
  $.ajax({
    type: "POST",
    url: config.shopifyAjaxChangeURL,
    data: "quantity=" + quantity + "&id=" + variantID,
    dataType: "json",
    success: function (data) {
      updateMiniCartContents();
      //TODO
      disableMinusModifier();
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
      console.log(response);
    },
  });
}

//BG & MG: Allow the user to increase or decrease their quantity in the mini basket.
function quantityControl() {
  $(".cart-item-quantity-control")
    .off()
    .on("click", function () {
      var cartItemID = $(this).parents(".cart-item").attr("data-cart-item-id");

      var cartItemQuantityValue = parseInt(
        $(this).parents(".cart-item").find(".cart-item-quantity").val()
      );

      if ($(this).hasClass("minus")) {
        if (cartItemQuantityValue > 1) {
          cartItemQuantityValue--;
        }
      } else if ($(this).hasClass("plus")) {
        cartItemQuantityValue++;
      } 

      /* if ($(this).hasClass("minus") && (cartItemQuantityValue = 1)) {
        ($(this).addClass("disabled").attr(disabled));
      } */

      if ($(this).hasClass("minus")) {
        if (cartItemQuantityValue === 1) {
          $(this).addClass("disabled").attr("disabled");
        }
        else if (cartItemQuantityValue > 1) {
          $(this).removeClass("disabled").removeAttr("disabled");
        };
      };

      $(this).parents(".cart-item").find(".cart-item-quantity").val(cartItemQuantityValue);
      newQuantity(cartItemID, cartItemQuantityValue);
    });
}

/**
 * BG: Consolodating Michael's functions. Toggle the open and close state of the cart based on a class.
 */
function cartDrawToggle() {
    //console.log('fire cartDrawToggle');
    //If the header basket has the hover class, we can assume it was already open, therefore we close it. Otherwise....we open it. 
    if ($(".header-basket").hasClass('hover')) {
        $(".header-basket").removeClass("hover");
        $(".cart-mini-bg-overlay").removeClass("overlay-active");
        $("html").removeClass("overflow-hidden");
    } else {
        $(".header-basket").addClass("hover");
        $(".cart-mini-bg-overlay").addClass("overlay-active");
        $("html").addClass("overflow-hidden");
    }
}

$(".header-basket .cart-icon-hyperlink, .header-basket #close-btn, .header-basket .cart-mini-bg-overlay").on('click', function(){
    cartDrawToggle();
});

$(document).ready(function () {
  if ($("body").hasClass("template-cart")) {
    //cartItemQuantity();
    //cartItemVariantSize();
    cartItemQuantityVariant();
  }

  removeCartItemTrigger();
  quantityControl();

  $(config.addToCartFormSelector).submit(function (e) {
    e.preventDefault();
    addToCart($(this));
  });
});
//BG: Init slickSlider for Recently Viewed and Related Products.
function recentSlickSlider(target) {
  $(target).slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: slickPrevArrow,
    nextArrow: slickNextArrow,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  });

  //resizeTrackHeight(target);

  $(window).on("resize", function () {
    //resizeTrackHeight(target);
  });
}

//BG: Grab the recently viewed products array, and loop through the products and output them.
function retrieveRecentlyViewedProducts(array, outputLocation, maxProducts) {
  //if the array is greater than max allowed products, delete the last product from the array.
  if (array.length > maxProducts) {
    array.shift();
  }

  //if there are products to display, remove the hidden class.
  if (array.length > 0) {
    $(outputLocation).removeClass("d-none");
  }

  // loop for the array, and output the products.
  $.each(array, function (i, product) {
    //ensure the product isn't undefined.
    if (product != "undefined.js" && product != ".js") {
      //make a json request based on the product handle.
      var ajax = $.getJSON("/products/" + product, function (data) {
        //pass the data over to the below function
        outputProduct(data, outputLocation);
      }).fail(function () {
        //BG: This should rarely happen, but if the product is no longer available, we get a json error, so want to remove the product from the array.
        console.log(
          "product not found, but it will be removed from array on next page load"
        );
        var arrayFix = array.indexOf(product);
        if (arrayFix !== -1) {
          array.splice(arrayFix, 1);
        }
        //BG: Update localStorage
        localStorage.setItem("recentProducts", JSON.stringify(arrayFix));
      });
    }

    //Check to see if it's the last item in the Array, if it is...
    var increment = i + 1;

    if (array.length == increment) {
      persistentCheck(
        ".featured-products.product-recently-viewed .featured-product",
        4,
        recentSlickSlider,
        ".featured-products.product-recently-viewed .featured-products-slick",
        5000
      );
    }
  });
}

//BG: Add current product to the recently viewed array
function addNewProduct(array, productHandle, maxProducts) {
  //BG: if array is greater than the maxProducts, then delete the first item in the array
  if (array.length > maxProducts) {
    array.shift();
  }

  //BG: only add the product to the array, if it doesn't already exist
  if (array.indexOf(productHandle) == -1 && productHandle != "undefined.js") {
    array.push(productHandle);
  }
  //BG: Update localStorage
  localStorage.setItem("recentProducts", JSON.stringify(array));
}

//BG: Using localStorage, we create an array based on the products the user has been viewing. When they visit a product page, it stores the product handle.
function recentlyViewedProducts() {
  //Retrieve localstorage for recentproducts(if it exists)
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")),
    outputLocation = ".product-recently-viewed",
    newProduct = $(outputLocation).attr("data-product-handle");
  (newProduct = newProduct + ".js"), (maxProducts = 6);

  //if localstorage exists, retrieve the list and output it
  if (savedRecentProducts) {
    retrieveRecentlyViewedProducts(
      savedRecentProducts,
      outputLocation,
      maxProducts
    );
    addNewProduct(savedRecentProducts, newProduct, maxProducts);
  } else {
    //First time user has visited a product page, so let's create the new local storage.
    //console.log('doesn\'t exist, let\'s make a new array');
    var recentProducts = [];
    addNewProduct(recentProducts, newProduct, maxProducts);
  }
}

recentlyViewedProducts();
function clearSearchResults() {
    $('.predictive-search-form .predictive-search-results .results').html('');
}

function clearSearch() {
    var searchField = $('.predictive-search-form .input-search'),
        clearInput = $('.predictive-search-form .clear-input');

    clearInput.on('click', function(){
        searchField.val("");
        clearSearchResults();
        $('.predictive-search-form').removeClass('has-results');
        $('.predictive-search-form button[type="submit"]').removeClass('stay-active');
    });
}

/* BG: Output the product suggestions  */
function outputSuggestions(product) {
    var productHTML = "";

    productHTML += '<li class="result-item" data-product-id="'+product['id']+'">';
        productHTML += '<a href="'+product['url']+'">';
        productHTML += '<span class="result-item-image">';
        if (product['image'] != null) {
            productHTML += '<img src="'+slate.Image.getSizedImageUrl(product['image'],'100x')+'" alt="'+product['title']+'" class="img-fluid" />';
        } else {
            productHTML += svgPlaceholder;
        }
        productHTML += '</span>';
        productHTML += '<span class="result-item-detail">';
            productHTML += '<h3 class="product-title">'+product['title']+'</h3>';
            if (product['available']) {
                productHTML += '<span class="product-price"><span class="money">'+slate.Currency.formatMoney(product['price_min'], theme.moneyFormat)+'</span></span>';
            } else {
                productHTML += '<span class="soldout">Sold Out</span>';
            }
        productHTML += '</span>';
        productHTML += '</a>';
    productHTML += '</li>';

    //only add the product if it doesn't already exisit
    if ($('.predictive-search-results li.result-item[data-product-id="'+product['id']+'"]').length === 0) {
        $('.predictive-search-form .predictive-search-results .results').prepend(productHTML);
    }
}

/*BG: The predictive search API. for more info visit https://help.shopify.com/en/themes/development/search/predictive-search */
function searchAPI(query) {
    jQuery.getJSON("/search/suggest.json", {
        "q": query,
        "resources": {
        "type": "product",
        "limit": 4,
        "options": {
            "unavailable_products": "last",
            //BG: fields we are searching on
            "fields": "title,variants.title,variants.sku"
        }
    }
    }).done(function(response) {
        let WPD_handels='';
        for(var i=0;i<response.resources.results.products.length;i++) {
          WPD_handels+=response.resources.results.products[i].handle +',';
        }

        var wcpcartdata = [];
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            wcpcartdata=JSON.parse(this.responseText);
          }
        };          
        xhttp.open("GET", '/search/?view=wcp_discount_api&handle='+WPD_handels, false);
        xhttp.send();

        for(var i=0;i<response.resources.results.products.length;i++) { 
          for(var j=0;j<wcpcartdata.products.length;j++){
            if(response.resources.results.products[i].id == wcpcartdata.products[j].id){
              response.resources.results.products[i].price=wcpcartdata.products[j].variants[0].wpd_price;          
              response.resources.results.products[i].price_min=wcpcartdata.products[j].wpd_price_min;
              response.resources.results.products[i].price_max=wcpcartdata.products[j].wpd_price_max;
              response.resources.results.products[i].compare_at_price_max=wcpcartdata.products[j].wpd_compare_at_price_max;
              response.resources.results.products[i].compare_at_price_min=wcpcartdata.products[j].wpd_compare_at_price_min;
            }
          }       
        }
        var productSuggestions = response.resources.results.products;
    
        //if productSuggestions has results
        if (productSuggestions.length > 0) {
            //console.log(productSuggestions);

            //for each product
            for (var key in productSuggestions) {
                var product = productSuggestions[key];
                outputSuggestions(product);
            }
        } else {
            var noResults = '<li class="no-results">No Results</li>';
            if ($('.predictive-search-results li.no-results').length === 0) {
                $('.predictive-search-form .predictive-search-results .results').append(noResults);
            }
        }
    });
}


function searchInput() {
    var searchField = $('.predictive-search-form .input-search');

    searchField.on('input', function() { 
        var value = $(this).val() 
        //only trigger if input value length is 3 or greater. No point searching on one or two characters.
        if (value.length >= 3) {
            //clear the search results if the user continues to input 
            clearSearchResults();
            //for each input, run the query
            searchAPI(value);
            $(this).parent('.predictive-search-form').addClass('has-results');
            $(this).parent('.predictive-search-form').find('button[type="submit"]').addClass('stay-active');
        } else {
            $(this).parent('.predictive-search-form').removeClass('has-results');
            $(this).parent('.predictive-search-form').find('button[type="submit"]').removeClass('stay-active');
        }
    });

    clearSearch();
}

searchInput();
function cookieBanner() {

    var cookieBar = $('.cookie-bar'),
        cookieValue = getCookie('cookie-bar'),
        cookieBtn = $('.cookie-bar .btn');

    if (!cookieValue) {
        cookieBar.removeClass('d-none');
    }

    cookieBtn.on('click', function(){
        cookieBar.addClass('d-none');
        setCookie('cookie-bar','accepted',60);
    });

}

cookieBanner();
/**
 * BG: We have to use a cookie over local storage, as a cookie works across subdomains.
 */
 function geoSetCookie(cname, cvalue, exdays) {
    //console.log("set cookie!");
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.garadry.com;path=/";
}

function geoGetCookie(cname) { 
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}


function geoLocation() {
    //console.log("geo!");

    var stayOnStorePreference = geoGetCookie("cookieGaradryStayOnStoreThree"),
        cookieStorePreference = geoGetCookie("cookieGaradyStorePreferenceThree"),
        storeAddress = $('.store-redirect').attr('data-store-address'),
        redirectPopup = $('.redirect-popup'),
        redirectOverlay = $('.redirect-overlay'),
        redirectTargetCountry = $('.redirect-content .target-country'),
        redirectButtonLink = $('.redirect-content .btn-redirect'),
        URLPath = window.location.pathname;

        //BG: For testing purposes, if the current url contains myshopify, assume we're on the shopify urls. Else...we're on the live domains.
        if (window.location.host.indexOf('myshopify') >= 0) {
            //console.log("shopify domains");
            var StoreITURL = "https://weather-stop-it.myshopify.com";
            var StoreDEURL = "https://weatherstop-de.myshopify.com";
            var StoreDKURL = "https://weather-stop-dk.myshopify.com";
            var StoreFRURL = "https://weather-stop-fr.myshopify.com";
            var StoreAUURL = "https://weather-stop-au-nz.myshopify.com";
            var StoreUKURL = "https://yellowproduct.myshopify.com";
            var StoreUSURL = "https://garadry.myshopify.com";
        } else {
            //console.log("live domains");
            var StoreITURL = "https://it.garadry.com";
            var StoreDEURL = "https://de.garadry.com";
            var StoreDKURL = "https://dk.garadry.com";
            var StoreFRURL = "https://fr.garadry.com";
            var StoreAUURL = "https://au.garadry.com";
            var StoreUKURL = "https://uk.garadry.com";
            var StoreUSURL = "https://us.garadry.com";
        }


        //console.log({stayOnStorePreference});
        //console.log({cookieStorePreference});

    // If customer has not clicked 'Stay on Store' or changed site in site select.
    if (stayOnStorePreference == "") {
        //console.log("stay on store preference");
        //If store preference is not set....
        if (cookieStorePreference == "") {
            //console.log('preference not set');

            $.ajax({
                url: '//api.ipstack.com/check?access_key=dd6e7a679055037e185bcd0b9222380c',
                dataType: 'json',
                success: function (json) {

                    //console.log("fire json");
                    //If customer is from Italy
                    if (json.country_code == "IT") {
                        //Check to see if store is also IT
                        if (storeAddress.indexOf('weather-stop-it') >= 0 || storeAddress.indexOf('it.garadry.com') >= 0) {
                            //If customer and store are both IT, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "IT", 365)
                        } else {
                            //show redirect popup - with option to redirect to IT.
                            $(redirectTargetCountry).html('IT');
                            $(redirectButtonLink).attr('href', StoreITURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "DE") {
                        //Check to see if store is also DE
                        if (storeAddress.indexOf('weatherstop-de') >= 0 || storeAddress.indexOf('de.garadry.com') >= 0) {
                            //If customer and store are both DE, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "DE", 365)
                        } else {
                            //show redirect popup - with option to redirect to DE.
                            $(redirectTargetCountry).html('DE');
                            $(redirectButtonLink).attr('href', StoreDEURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "DK") {
                        //Check to see if store is also DK
                        if (storeAddress.indexOf('weather-stop-dk') >= 0 || storeAddress.indexOf('dk.garadry.com') >= 0) {
                            //If customer and store are both DK, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "DK", 365)
                        } else {
                            //show redirect popup - with option to redirect to DE.
                            $(redirectTargetCountry).html('DK');
                            $(redirectButtonLink).attr('href', StoreDKURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "FR") {
                        //Check to see if store is also FR
                        if (storeAddress.indexOf('weather-stop-fr') >= 0 || storeAddress.indexOf('fr.garadry.com') >= 0) {
                            //If customer and store are both FR, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "FR", 365)
                        } else {
                            //show redirect popup - with option to redirect to FR.
                            $(redirectTargetCountry).html('FR');
                            $(redirectButtonLink).attr('href', StoreFRURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "AU" || json.country_code == "NZ") {
                        //Check to see if store is also AU
                        if (storeAddress.indexOf('weather-stop-au-nz') >= 0 || storeAddress.indexOf('au.garadry.com') >= 0) {
                            //If customer and store are both AU, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "AU", 365)
                        } else {
                            //show redirect popup - with option to redirect to AU.
                            $(redirectTargetCountry).html('AU');
                            $(redirectButtonLink).attr('href', StoreAUURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.country_code == "GB") {
                        //Check to see if store is also GB
                        if (storeAddress.indexOf('yellowproduct') >= 0 || storeAddress.indexOf('uk.garadry.com') >= 0) {
                            //If customer and store are both GB, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "UK", 365)
                        } else {
                            //show redirect popup - with option to redirect to GB.
                            $(redirectTargetCountry).html('UK');
                            $(redirectButtonLink).attr('href', StoreUKURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else if (json.continent_code == "NA" || json.continent_code == "SA") {
                        //Check to see if store is also US
                        if (storeAddress === ("garadry.myshopify.com") || storeAddress.indexOf('us.garadry.com') >= 0) {
                            //If customer and store are both US, do nothing. They are were they are supposed to be.
                            //set user store preference
                            geoSetCookie("cookieGaradyStorePreferenceThree", "US", 365)
                        } else {
                            //show redirect popup - with option to redirect to US.
                            $(redirectTargetCountry).html('US');
                            $(redirectButtonLink).attr('href', StoreUSURL + URLPath);
                            $(redirectPopup).addClass('active');
                            $(redirectOverlay).addClass('active');
                        }
                    } else {
                        //If customer is from Rest of the World, no matter the store we show the select on the popup
                        //Check to see if store is also US
                        $(redirectPopup).addClass('active');
                        $(redirectOverlay).addClass('active');
                        $('.redirect-popup .inital-content').addClass('d-none');
                        $('.redirect-popup .decision-content').removeClass('d-none');
                        $('.redirect-popup .btn-redirect').addClass('d-none');
                        $('.redirect-popup .redirect-currency-select').removeClass('d-none');
                    }
                }
            });

        //IF store preference is set.   
        } else if (cookieStorePreference == "IT") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is IT. 
            if (storeAddress.indexOf('weather-stop-it') >= 0 || storeAddress.indexOf('it.garadry.com') >= 0) {
                // and customer is on IT store. Do nothing. 
            } else {
                window.top.location.href = StoreITURL + URLPath; 
            }
        } else if (cookieStorePreference == "DE") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is DE. 
            if (storeAddress.indexOf('weatherstop-de') >= 0 || storeAddress.indexOf('de.garadry.com') >= 0) {
                // and customer is on DE store. Do nothing. 
            } else {
                window.top.location.href = StoreDEURL + URLPath;
            }
        } else if (cookieStorePreference == "DK") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is DK. 
            if (storeAddress.indexOf('weather-stop-dk') >= 0 || storeAddress.indexOf('dk.garadry.com') >= 0) {
                // and customer is on DK store. Do nothing. 
            } else {
                window.top.location.href = StoreDKURL + URLPath;
            }
        } else if (cookieStorePreference == "FR") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is FR. 
            if (storeAddress.indexOf('weather-stop-fr') >= 0 || storeAddress.indexOf('fr.garadry.com') >= 0) {
                // and customer is on FR store. Do nothing. 
            } else {
                window.top.location.href = StoreFRURL + URLPath;
            }
        } else if (cookieStorePreference == "AU") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is AU. 
            if (storeAddress.indexOf('weather-stop-au-nz') >= 0 || storeAddress.indexOf('au.garadry.com') >= 0) {
                // and customer is on AU store. Do nothing. 
            } else {
                window.top.location.href = StoreAUURL + URLPath;
            }
        } else if (cookieStorePreference == "UK") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is UK. 
            if (storeAddress.indexOf('yellowproduct') >= 0 || storeAddress.indexOf('uk.garadry.com') >= 0) {
                // and customer is on UK store. Do nothing. 
            } else {
                window.top.location.href = StoreUKURL + URLPath;
            }
        } else if (cookieStorePreference == "US") {
            //console.log('preference:' +cookieStorePreference);

            //IF store preference is US. 
            if (storeAddress === ("garadry.myshopify.com") || storeAddress.indexOf('us.garadry.com') >= 0) {
                // and customer is on US store. Do nothing. 
            } else {
                window.top.location.href = StoreUSURL + URLPath; 
            }
        }

      // If customer has set a preference with 'Stay on Store' or changed site in site select and they land on another store - ask if they want to be redirected to their prefered store.
    } else if (stayOnStorePreference == "IT") {
        //IF store preference is IT. 
        if (storeAddress.indexOf('weather-stop-it') >= 0 || storeAddress.indexOf('it.garadry.com') >= 0) {
            // and customer is on IT store. Do nothing. 
        } else {
            window.top.location.href = StoreITURL + URLPath;
        }
    } else if (stayOnStorePreference == "DE") {
        //IF store preference is DE. 
        if (storeAddress.indexOf('weatherstop-de') >= 0 || storeAddress.indexOf('de.garadry.com') >= 0) {
            // and customer is on DE store. Do nothing. 
        } else {
            window.top.location.href = StoreDEURL + URLPath;
        }
    } else if (stayOnStorePreference == "DK") {
        //IF store preference is DK. 
        if (storeAddress.indexOf('weather-stop-dk') >= 0 || storeAddress.indexOf('dk.garadry.com') >= 0) {
            // and customer is on DK store. Do nothing. 
        } else {
            window.top.location.href = StoreDKURL + URLPath;
        }
    } else if (stayOnStorePreference == "FR") {
        //IF store preference is FR. 
        if (storeAddress.indexOf('weather-stop-fr') >= 0 || storeAddress.indexOf('fr.garadry.com') >= 0) {
            // and customer is on FR store. Do nothing. 
        } else {
            window.top.location.href = StoreFRURL + URLPath;
        }
    } else if (stayOnStorePreference == "AU") {
        //IF store preference is AU. 
        if (storeAddress.indexOf('weather-stop-au-nz') >= 0 || storeAddress.indexOf('au.garadry.com') >= 0) {
            // and customer is on AU store. Do nothing. 
        } else {
            window.top.location.href = StoreAUURL + URLPath;
        }
    } else if (stayOnStorePreference == "UK") {
        //IF store preference is UK. 
        if (storeAddress.indexOf('yellowproduct') >= 0 || storeAddress.indexOf('uk.garadry.com') >= 0) {
            // and customer is on UK store. Do nothing. 
        } else {
            window.top.location.href = StoreUKURL + URLPath;
        }
    } else if (stayOnStorePreference == "US") {
        //IF store preference is US. 
        if (storeAddress === ("garadry.myshopify.com") || storeAddress.indexOf('us.garadry.com') >= 0) {
            // and customer is on US store. Do nothing. 
        } else {
            window.top.location.href = StoreUSURL + URLPath;
        }
    }
    
}

/**
 * BG: This function allows the customer to override and change their preference, by selecting a new store via the header dropdown.
 */
function countrySelectChange() {
    var link = $('.country-select a');
    link.on("click", function(e){
        e.preventDefault(); 

        var value = $(this).text(),
            linkhref = $(this).attr('href'); 

        if (linkhref.indexOf('weather-stop-it') >= 0 || linkhref.indexOf('it.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "IT", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "IT", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref.indexOf('weatherstop-de') >= 0 || linkhref.indexOf('de.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "DE", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "DE", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref.indexOf('weather-stop-dk') >= 0 || linkhref.indexOf('dk.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "DK", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "DK", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref.indexOf('weather-stop-fr') >= 0 || linkhref.indexOf('fr.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "FR", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "FR", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref.indexOf('weather-stop-au-nz') >= 0 || linkhref.indexOf('au.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "AU", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "AU", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref.indexOf('yellowproduct') >= 0 || linkhref.indexOf('uk.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "UK", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "UK", 365)
            window.top.location.href = linkhref; 
        } else if (linkhref === ("garadry.myshopify.com") || linkhref.indexOf('us.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "US", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "US", 365)
            window.top.location.href = linkhref; 
        }
    })
}

function redirectClose() {
    $('.redirect-close').off('click').on('click', function(){

        var storeAddress = $('.store-redirect').attr('data-store-address');

        $('.redirect-popup').removeClass('active');
        $('.redirect-overlay').removeClass('active');

        if (storeAddress.indexOf('weather-stop-it') >= 0 || storeAddress.indexOf('it.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "IT", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "IT", 365)
        } else if (storeAddress.indexOf('weatherstop-de') >= 0 || storeAddress.indexOf('de.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "DE", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "DE", 365)
        } else if (storeAddress.indexOf('weather-stop-dk') >= 0 || storeAddress.indexOf('dk.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "DK", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "DK", 365)
        } else if (storeAddress.indexOf('weather-stop-fr') >= 0 || storeAddress.indexOf('fr.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "FR", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "FR", 365)
        } else if (storeAddress.indexOf('weather-stop-au-nz') >= 0 || storeAddress.indexOf('au.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "AU", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "AU", 365)
        } else if (storeAddress.indexOf('yellowproduct') >= 0 || storeAddress.indexOf('uk.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "UK", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "UK", 365)
        } else if (storeAddress === ("garadry.myshopify.com") || storeAddress.indexOf('us.garadry.com') >= 0) {
            geoSetCookie("cookieGaradyStorePreferenceThree", "US", 365)
            geoSetCookie("cookieGaradryStayOnStoreThree", "US", 365)
        }

    });
}


function redirectCheck() {
   var storeRedirect = $('.store-redirect'); 

   if (storeRedirect.length) {
       geoLocation();
       countrySelectChange();
       redirectClose();
   }
}

redirectCheck();

$(document).ready(function() {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
  
    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));
  
    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
  
    // Target tables to make them scrollable
    var tableSelectors = '.rte table';
  
  //   slate.rte.wrapTable({
  //     $tables: $(tableSelectors),
  //     tableWrapperClass: 'rte__table-wrapper',
  //   });
  
    // Target iframes to make them responsive
    var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';
  
    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'rte__video-wrapper'
    });
  
    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }
  });
  
  /* ==========================================================================
  #Custom Velstar
  ========================================================================== */
  
  // AOS.init({
  //     // Global settings:
  //     disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  //     startEvent: 'load', // name of the event dispatched on the document, that AOS should initialize on
  //     initClassName: 'aos-init', // class applied after initialization
  //     animatedClassName: 'aos-animate', // class applied on animation
  //     useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  //     disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  //     debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  //     throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      
  //     // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  //     offset: 120, // offset (in px) from the original trigger point
  //     delay: 0, // values from 0 to 3000, with step 50ms
  //     duration: 1000, // values from 0 to 3000, with step 50ms
  //     easing: 'ease', // default easing for AOS animations
  //     once: true, // whether animation should happen only once - while scrolling down
  //     mirror: false, // whether elements should animate out while scrolling past them
  //     anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  // });
  // window.addEventListener('load', function() {
  // 	AOS.refresh();
  // });
  
  //product page swatch change
  $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
  });

